import {ToolbarType} from "@syncfusion/ej2-react-richtexteditor";

export enum HttpStatusCode {
  CONTINUE = 100,
  SWITCHING_PROTOCOLS = 101,
  PROCESSING = 102,
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NON_AUTHORITATIVE_INFORMATION = 203,
  NO_CONTENT = 204,
  RESET_CONTENT = 205,
  PARTIAL_CONTENT = 206,
  MULTI_STATUS = 207,
  ALREADY_REPORTED = 208,
  IM_USED = 226,
  MULTIPLE_CHOICES = 300,
  MOVED_PERMANENTLY = 301,
  FOUND = 302,
  SEE_OTHER = 303,
  NOT_MODIFIED = 304,
  USE_PROXY = 305,
  SWITCH_PROXY = 306,
  TEMPORARY_REDIRECT = 307,
  PERMANENT_REDIRECT = 308,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  PROXY_AUTHENTICATION_REQUIRED = 407,
  REQUEST_TIMEOUT = 408,
  CONFLICT = 409,
  GONE = 410,
  LENGTH_REQUIRED = 411,
  PRECONDITION_FAILED = 412,
  PAYLOAD_TOO_LARGE = 413,
  URI_TOO_LONG = 414,
  UNSUPPORTED_MEDIA_TYPE = 415,
  RANGE_NOT_SATISFIABLE = 416,
  EXPECTATION_FAILED = 417,
  I_AM_A_TEAPOT = 418,
  MISDIRECTED_REQUEST = 421,
  UNPROCESSABLE_ENTITY = 422,
  LOCKED = 423,
  FAILED_DEPENDENCY = 424,
  UPGRADE_REQUIRED = 426,
  PRECONDITION_REQUIRED = 428,
  TOO_MANY_REQUESTS = 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE = 431,
  UNAVAILABLE_FOR_LEGAL_REASONS = 451,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
  HTTP_VERSION_NOT_SUPPORTED = 505,
  VARIANT_ALSO_NEGOTIATES = 506,
  INSUFFICIENT_STORAGE = 507,
  LOOP_DETECTED = 508,
  NOT_EXTENDED = 510,
  NETWORK_AUTHENTICATION_REQUIRED = 511,
}

export enum PageNames {
  MAINTENANCE = "Maintenance",
  LOGIN = "Login",
  CHANGEPASSWORD = "Change Password",
  FIRSTTIMELOGIN = "First Time Login",
  FORGOTPASSWORD = "Forgot Password",
  REQUESTACCOUNT = "Request Account",
  USERPROFILE = "User Profile",
  MFAPREFERRED = "MFA Preferred",
  DASHBOARD = "Dashboard",
  ALERTS = "Alerts",
  REPORTS = "Reports",
  SWITCHAPPLICATION = "Switch Application",
  MESSAGES = "Messages",
  FACULTY = "Faculty",
  MASTER_LAYOUT = "Master Layout",
  ADMIN = "Admin",
  RESOURCES = "Resources",
  ACTIVITY = "Activity",
}

export enum AxiosErrorCode {
  ECONNABORTED = "ECONNABORTED",
  ERR_NETWORK = "ERR_NETWORK",
  ERR_BAD_REQUEST = "ERR_BAD_REQUEST",
  ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE",
}

export enum FileExtension {
  FOLDER = "",
  FILE = "File",
  FOLDER_TEXT = "Folder",
  TXT = ".txt",
  ASP = ".asp",
  PHP = ".php",
  PHP5 = ".php5",
  PHT = ".pht",
  JSP = ".jsp",
  EXE = ".exe",
  PDF = ".pdf",
  DOCX = ".docx",
  DOC = ".doc",
  DOT = ".dot",
  XLSX = ".xlsx",
  XLX = ".xlx",
  XLS = ".xls",
  XLT = ".xlt",
  XLA = ".xla",
  XML = ".xml",
  PPTX = ".pptx",
  PPT = ".ppt",
  POT = ".pot",
  PPS = ".pps",
  PPA = ".ppa",
  HTM = ".htm",
  HTML = ".html",
  PHTML = ".phtml",
  SHTML = ".shtml",
  ASA = ".asa",
  CER = ".cer",
  ASAX = ".asax",
  SWF = ".swf",
  XAP = ".xap",
  KAL = ".kal",
  RTF = ".rtf",
  MP3 = ".mp3",
  MP4 = ".mp4",
  XSL = ".xsl",
  ZIP = ".zip",
  WMV = ".wmv",
  WAV = ".wav",
  MOV = ".mov",
  MPEG = ".mpeg",
  WEBP = ".webp",
  PNG = ".png",
  JPG = ".jpg",
  JPEG = ".jpeg",
  BMP = ".bmp",
  GIF = ".gif",
  TIFF = ".tiff",
  KEY = ".key",
  PARTIAL = ".partial",
  OCTET = "",
  CSV = ".csv",
  PDFX = ".pdfx",
}

export enum FileMIMEType {
  PDF = "application/pdf",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC = "application/msword",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  XLS = "application/vnd.ms-excel",
  XLA = "application/vnd.ms-excel",
  XLT = "application/vnd.ms-excel",
  PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  PPT = "application/vnd.ms-powerpoint",
  PPA = "application/vnd.ms-powerpoint",
  PPS = "application/vnd.ms-powerpoint",
  HTML = "text/html",
  XML = "application/rss+xml",
  RTF = "application/rtf",
  TXT = "text/plain",
  MP3 = "audio/mp3",
  MP4 = "video/mp4",
  XSL = "application/xml",
  WMV = "video/x-ms-wmv",
  MOV = "video/quicktime",
  MPEG = "video/mpeg",
  WEBP = "image/webp",
  PNG = "image/png",
  JPG = "image/jpg",
  JPEG = "image/jpeg",
  BMP = "image/bmp",
  GIF = "image/gif",
  TIFF = "image/tiff",
  PARTIAL = "message/partial",
  ZIP = "application/zip",
  OCTET = "application/octet-stream",
}

export enum Faculty {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export enum Alerts {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export enum Activity {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}

export enum CPSMessages {
  LOGOUT_SUCCESSFULLY = "You logged out successfully.",
  ISPIACCESSEMESSAGE = "Authorized users only. Please contact the Administrator for further assistance.",
  SESSION_EXPIRED = "Your login session expired.",
  LOGOUT_ANOTHER_SYSTEM = "You have logged into another system",
  EXCEPTION_HANDLER_TITLE = "An unexpected error occurred in the application.",
  PASSWORD_MEET = "Your password must meet the following criteria:",
  SOMETHING_WENT_WRONG = "Some thing went wrong.",
  OLD_NEW_NOT_MATCH = "Old password and new password are same enter different new password.",
  PASSWORD_NOT_MATCH = "Password do not match.",
  PLEASE_SELECT_ONE_CHECKBOX = "Please select at least one checkbox.",
  SELECT_FIRST_SEQURITY_QUESTION = "Please select the first security question.",
  PLEASE_ENTER_USER_ID = "Please enter the User Id.",
  FIRST_QUESTION_ANSWER = "Please enter the answer for the first security question.",
  SECOND_QUESTION_ANSWER = "Please enter the answer for the second security question.",
  SELECT_SECOND_SEQURITY_QUESTION = "Please select the second security question.",
  SELECTPROFILEVALIDATION = "Please select a profile.",
  PLEASE_ENTER_PASSWORD = "Please enter the password.",
  PLEASE_REENTER_PASSOWRD = "Please re-enter the password.",
  ENTER_OLD_PASSWORD = "Please enter the old password.",
  ENTER_NEW_PASSWORD = "Please enter the new password.",
  ENTERFIRSTNAME = "Please enter the first name.",
  ENTERLASTNAME = "Please enter the last name.",
  ENTERTELENUM = "Please enter the telephone number.",
  ENTERVALIDTELE = "Please enter a Valid Telephone Number.",
  ENTEREMAILID = "Please enter the email address.",
  ENTERVALIDEMAIL = "Please enter a valid email address.",
  ENTERCOMPANY = "Please enter the company name.",
  ENTERSUPERVISOR = "Please enter the supervisor name.",
  ENTERSUPERVISOREMAIL = "Please enter the supervisor email id.",
  ENTERVALIDSUPERVISOREMAIL = "Please enter valid supervisor email address.",
  ENTERSUPERVISORPHONE = "Please enter the supervisor phone.",
  ENTERVALIDSUPERVISORNUM = "Please enter a valid Supervisor Telephone Number.",
  BUSINESSJUSTI = "Please enter the business justification.",
  BUSINESSJUSTIMINCHAR = "Business justification must be at least 35 characters.",
  SELECTCAPTCHA = "Please select the captcha.",
  ENTER_COST_CENTER_NAME = "Please enter cost center.",
  PASSWORD_CRITERIA = "Must contain 8-25 characters, one uppercase, one lowercase, one number, and one special character.",
  ANNOUNCEMENTSUCCESS = "The announcement is successfully removed.",
  DASHBOARDALERTNODATA = "There are no Alerts.",
  RESOURCENODATA = "No Resource content exists in this folder",
  DASHBOARDMSGNODATA = "There are no messages.",
  DUPLICATE_TAB_ALERT = "Can't open multiple instances of this site.",
  INTERNAL_SERVER_ERROR = "Service unavailable. Please try after sometime.",
  SERVICE_NOT_FOUND = "The Resources you are trying to access does not exist. Please refresh the page and try again. If the issue persists, kindly contact system adminitsrator.",
  SYSTEM_ERROR = "Some thing went wrong.",
  TIMEOUT_ERROR = "We apologize, but it seems that our server is currently experiencing a delay in responding to your request. Please refresh the page and try again. If the issue persists, kindly wait for a few moments before attempting again. Thank you for your patience.",
  NETWORK_ERROR = "Network Error.",
  REQ_EXCEPTION_TEXT = "To request an exception please click on the below link.",
  PLEASE_FILL_OTP = "Please enter OTP.",
  LINK_INACTIVE = "Reset password link has expired.",
  CONTACT_SUPPORT = "Error: Please try again or contact support 866-277-6024.",
  PREVIEW_URL_NOT_FOUND = "No Preview found.",
  ORF_DRAFT_MESSAGE = "By clicking the save button, the EAF will be saved as a draft.",
}

export enum CPSNumbers {
  MINUS_TWO = -2,
  MINUS_ONE = -1,
  ZERO = 0,
  ONE = 1,
  ONE_POINT_FIVE = 1.5,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
  TEN = 10,
  ELEVEN = 11,
  TWELVE = 12,
  THIRTEEN = 13,
  FOURTEEN = 14,
  FIFTEEN = 15,
  EIGHTEEN = 18,
  NINTEEN = 19,
  EIGHTY_SEVEN = 87,
  NINETY_NINE = 99,
  TWENTY_THREE = 23,
  FIVEHUNDRED = 500,
  TWENTY_FOUR = 24,
  TWENTY_FIVE = 25,
  ACTIVITY_TYPE_ID_MINUS_ONE = -1,
  ACTIVITY_TYPE_ID_THREE = 3,
  SIXTEEN = 16,
  SEVEENTEEN = 17,
  ACTIVITIY_TYPE_ID_FDA = 2,
  ACTION_TYPE_ID_ONE = 1,
  ACTION_TYPE_ID_TWO = 2,
  ACTION_TYPE_ID_SIX = 6,
  ACTION_TYPE_ID_SEVEN = 7,
  ACTION_TYPE_ID_EIGHT = 8,
  ACTION_TYPE_ID_NINE = 9,
  ACTION_TYPE_ID_TEN = 10,
  ACTION_TYPE_ID_ELEVEN = 11,
  ACTION_TYPE_ID_THIRDTEEN = 13,
  ACTION_TYPE_ID_SEVENTEEN = 17,
  ACTION_TYPE_ID_EIGHTTEEN = 18,
  THOUSAND_FOURTY_THREE = 10043,
  THOUSAND_FOURTY_SEVEN = 10047,
  TWO_HUNDRED_NINTEEN = 219,
  TWO_HUNDRED_TWENTY_TWO = 222,
  TWO_HUNDRED_SEVEN = 207,
  TEN_THOUSAND_TWO_NINTY_NINE = 10299,
  TEN_THOUSAND_ONE_FIFTY = 10150,
  SIXTY = 60,
  THOUSAND_FOUR = 1004,
  TWO_HUNDRED = 200,
  TWENTY_ONE = 21,
  EIGHTY_THREE = 83,
  ONE_HUNDRED = 100,
  THOUSAND_FIVE_HUNDRED = 1500,
  THOUSAND = 1000,
  TWO_HUNDRED_FIFTY = 250,
  TWO_THOUSAND = 2000,
  FIFTY = 50,
  TWENTY = 21,
  ONE_HUNDRED_EIGHTEEN = 118,
  FOURTY = 40,
}

export enum ADActivityTypes {
  Advising_Consulting = 1,
  FDA_Regulated_Program = 2,
  Discovery_Research_Medical_Research = 3,
}

export enum ARFActivityTypes {
  Single_Advisor_Activity = 1,
  Advisory_Boards = 2,
  Other_Service = 4,
}

export enum CPSMessageCodes {
  ZERO = 0,
  SIX_SEVEN_ONE_FOUR_SEVEN_ZERO_FOUR_SIX = 67147046,
  NOMINATE_VENUE_DIALOG = "54501,54509,54504,54507,54505,40066,54511,54516",
  FACULTY_BASIC_SEARCH_RESULT = "47816,49831,49830,50105,40052",
  FACULTY_ADVANCE_SEARCH = "8592101,47816,49831,49830,40052,50105,49807,46273,42533,42532,50101,5193614,5193615,5193616,519366,519369,519368,5193617,519367,5193613,519365,25196251,251956,25196250,5193630",
  FACULTY_PROFILE_CODES = "11898,40133,550003,550009,550016,550011,42414,31506,53040,42547,47202,5273705,5273702,7453902",
  FACULTY_CONRACTS_TAB = "67147022",
  ADD_TRAININGINFO_SERVER_MESSAGES = "46266,46267,22511,46226,40024,46312,49232",
  ADD_TEXT_MESSAGE_ALERT_DIALOG = "70501,70502,85524,42499",
  ADD_NON_HCP_AND_PATIEND = "496222,496226,44132,46308,46309,46256,46257,49830,49832,46258,49831,49809,46279,12377,12546,12573,49653,46310,12543,22501,26251",
  ADD_EDIT_AFFILIATION_MESSAGES = "54517",
  ADD_EDIT_LICENSE_MESSAGES = "42402,42403,42404,42405,42415,42413,42413,47807,47809",
  UPLOAD_LICENSE_MESSAGES = "42413,42414,42419,25196269",
  ADD_EDIT_VENUE_CATERER_MESSAGES = "54501,54509,54504,54507,54505,54511,54527,54502,54503,54506,40066,54508,54532,47511,54525,54537,54519,54529,54530,54531,53052,53051",
  TAXFORM_1099 = "521611,521612,521614,521613,521618,521617,521615,521616",
  HCP_CONTACT_NOTE_MESSAGES = "42540,42544,42541",
  ACTIVITY_MAP_MESSAGES = "41921,40014,41925,41926",
  ACTIVITY_STATS_MESSAGES = "41921,40014,41925,41926",
  SEARCH_VENUE_CATERER_MESSAGES = "54517,54518",
  ADD_EDIT_ADDRESS_DIALOG = "42202,12378,46268,41904,46271,46270,40066,44106,46273,12384,600112,46274,46275,12551,44108,44115,42331,42334,42333,47511",
  ADD_EDIT_Participant_DIALOG = "67147188,80024,44108,42330,49650,44104,44105,46268,41904,46271,40066,46270,44106,46273,46270,44115,46272,42414,31506,49830,49831,42490,42489,49658,8854303,8854304,8854301",
  ADD_EDIT_SBINDICATOR_DIALOG = "42321,42322,42336,42326,42327,12373,12382,46266,46267",
  FACULTY_REQUEST_PROFILE_DETAIL = "67147057,46256,49650,46257,46258,46259,46261,46263,49656,49657,49809,49830,49831,49832,49802,46265,46266,46267,67151003,8854302,8854303,49658,8854304,8854305,8854301",
  ADD_EDIT_PROFILE_SERVER_MESSAGES = "46266,46267,70507,6648505,6648502,46256,46257,46258,49809,49830,49831,46265,49825,49826,49802,49651,49652,42318,49650,46259,42201,70507,6768801,6768802,7177313,717738,717739,42488,6702009,6702008,42319,42320,6768806,42493,42492,46272,42490,49658,8854303,8854304,8854305",
  ADD_ADD_ORG_CONTACT_DIALOG_SERVER_MESSAGES = "46257,46258,44108,42489,42490",
  FACULTY_REQUEST_CONTACT_INFO_SERVER_MESSAGES = "496226,46279,12558,4330713,12377,12546,12573,22501,49653,496225,496222",
  FACULTY_REQUEST_CLIENT_SPONSOR_INFO_SERVER_MESSAGES = "44132,46308,46309,46310,26251,12543,22501",
  ADD_EDIT_FACULTY_TIERING_SERVER_MESSAGES = "140501,42497,140502,140503,140504,140505,140506,41882,519361,140534",
  ADD_MULTIPLE_FACULTY_SERVER_MESSAGES = "44132,42502,42503,42504,46310,12543,42505",
  FACULTY_CV_BIO_PICINFORMATION_SERVER_MESSAGES = "49233,49236,49238,49239,860137,49232",
  FACULTY_PPQ_ADVANCE_SEARCH_SERVER_MESSAGES = "49654,5193611,5193612",
  LICENSE_DELETE_MESSAGE = "67147056",
  FACULTY_ALLOCATION = "10736,10534,40516,40517,40518,10537,10538,10568,10569,10754,10737,10534,10531,10732,10737,10569,10759,36266,46267,46266",
  ADD_EDIT_EXPENSES_MESSAGES = "42491,40133,17602",
  REQUEST_FOR_FUNDS_MESSAGES = "10541,10755,10545,10543,10534,10735,10542,10571,10755,10535",
  ADD_NOTES_MESSAGES = "10761",
  BICOMPLIMIT = "130026",
  ACTIVITY_SERIES = "41816,41817,40133",
  ALERT_PREFERENCES_SCREEN = "42600,40020,41903,49804,42601,42602,42603",
  CONTENT_MANAGEMENT_FOLDER = "130501,130579",
  CONTENT_MANAGEMENT_FILE_DELETE = "85574",
  CONTENT_MANAGEMENT_FILE_EDIT = "85570,45138,85576,85575,85573,130590",
  CONTACT_NOTE_TYPE_CONFIG = "49111,49112,49113,49544",
  FACULTY_KEY_CHANGE = "41814,41815,41972,40255,41824",
  ADMIN_SERVER_MESSAGES = "10534,31801,31803,80220,80219,80221,41851,41852,41827,521701,521702,521705,521703,521706,521707,67147058,67147058,80276,521611,521614,521613,521620,86010,47519,49831,49830",
  UPDATE_DOC_ON_FILE = "41813,40133",
  COST_CENTER_INSERT = "41810,481004,86127",
  UPDATE_IO = "41811,41828,11889,41812",
  TAX_TEXT_CONFIGURATION = "25196301",
  ADD_NEW_AFFILIATION_CONTACT_NOTE = "41960,31834,80203,54519",
  ADD_NEW_ENTITY_DIALOG = "12192,12187,12195,80276",
  EDIT_SCREENING = "12189",
  ADD_REMOVE_BRANDS = "41851,41852,41827,19549,69112128,69112130,69112129",
  ADD_EDIT_TOOLTIP_DIALOG = "67147069,6598532",
  ADD_EDIT_COMMENT_DIALOG = "659851,659852,67147070",
  ARF_MESSAGES = "67147060,6598513,6598514,67147061,67147062,67147063,67147064,67147065,67147066,67147067,67147068",
  SUPPLIER_BRAND = "46584,46585,46574,46575,46576,41819,44532,44533,80271,46583,41941,41940,46580,46582,41942,41880,41933,130570,130574",
  FIELD_ALIGNMENT_MAPPING = "41839,50117,50118,41831,41832,41837,41833,41834,41838,41835,41836,41840",
  MFA_PREFERRED_MESSAGES = "7088008,7088016,7088017,7088011,7088023",
  ACCOUNT_LOCKED_DUE_TO_FAILED_ATTEMPTS = "12154",
  REQUEST_FORM_CONFIGURATION = "67147065,67147071,6598513,6598514,67147073,67147066,67147074,67147072,67147068,5760304",
  REQUEST_FORM_SUBMIT = "5760303,80132,5760305",
  MY_SCHEDULED_REPORTS_MESSAGES = "7580004,7580009,7580011,7580013,7580015,7580017,7580019",
  REPORTS_CRITERIA_MESSAGES = "7580005,7580017,7580019,7580022,7580023,7580024,7580025,7580026,7580027,7580028",
  ADVISING_CENTRAL_MEMBERS_MESSAGES = "41851,41852,41827,860418",
  ADD_COMMENTS_MESSAGES = "46610",
  INDIVIDUAL_PAYMENT_MESSAGES = "41960",
  ENTER_INFORMATION_MESSAGE = "40289",
  CREDENTIALS_FOR_PAYMENT_LIMITS_MESSAGES = "41851,41852,41827,860414",
  BUSINESS_AREA_MESSAGES = "40209,40210,41827,40289,40208",
  THERAPEUTIC_AREA_MESSAGES = "41851,41852,41827,49516,49517",
  INDIVIDUAL_PAYMENTS_MESSAGES = "860401,85577,860402,860403,860408,860404,860443,454013,860428,860442,860430,860429,860426,860427",
  DISTRICT_TERRITORY_MANAGER_MESSAGES = "6505523,6505524,86126,6505514",
  UPDATE_APPROVERS_MESSAGES = "41821,41822,41938,40311,40312,40314,41953,41954,41955,40072,40313,80140,8014180143,80144,80149,80150,80151,80152,80153,80154,41821,80176,80232,41950,41951,41952,40133,44132",
  SUPPLIER_LIST = "41823,31840,31842,41897,41898,41899,41900,41901,41902,41903,41901,41904,41905,41906,51100,51102,51101,51103,41944,41981,80058,80198,41990,41991,7088001,32704",
  BRAND_APPROVERS = "41851,41852,41827,41800",
  APRROVERS_ASSIGNMENT = "44533,44532,46544,41978,46539,46538",
  SPP_NOTIFICATION = "67147058,42541",
  SPP_ANNUAL_NOTIFICATION_TRIGGER = "67147082,67147083",
  ASSIGNER_ALIGNMENT = "80276,41851,41852,80274,80275,80263,46551",
  ADD_EDIT_BRAND_SUBBRAND_LOGO = "481005,67147078,481006,67147079,67147077,481004,67147080,67147081",
  ADD_EDIT_BRAND_SUBBRAND = "31835,31836,317012,5761300,5761301,317011,317015,317017,317014,317015,49506,49507,49508,49509,860410,49518,41969,41826,46223,40077,31834,8492502",
  FACULTY_SELECTIO_RULES = "80264,80265,80266,80268,80270,80271,80269,80267",
  ALIGNMENT_LIMITS = "80263,80258,80259,80260",
  TOPIC_TRAINING_REQUIREMENT = "49511,49512,49538,41806,80044,11103,31502,49533,49534,41806,41807,49513,49542,49514,49531,49543,41880,41881,49549,251998,67147086,251999,49532,49540,47060,41888,49535,49545,49547,49536,49546,49548,49537,41883,41884,41885,49539,49544,11102,11101,8147701,8147702,8147703,8147704,8147705,8147706,8147709",
  CONTRACT_MANAGEMENT = "6913925,6913906,6913907,67147092,67147091,41970,46314,46315,46231,46229,46227,46228,46233,46242,46302,67147093,46234,46232,46243,260004,46254,40133,6913901,6913902,521703",
  CONTRACT_HISTORY = "46253,46227,46228,46254,46255,46252,46234,46302,46251,40133",
  CONTRACT_MANAGEMENT_UPLOAD = "67147094,67147095,80024",
  TOPIC_TRAINING_ADMIN = "41965,41992,41963,40303,40304,41994,41993,41964,41908,41909,41968,41962,41966,41965,41967,53040,41969,41817,40133,40024,41830,10757,42305,31507",
  CREDENTIALS_SPECIALTY = "41962,7387717,7387718,7387715,7387716",
  USER_LIST = "22005",
  CONTRACT_TEMPLATE_MESSAGES = "41851,41852,41827,41914,67147090,80023,41911,41912,41915,41918,860132,41939,6702001,41913,41914,41917,41919,41920,41921,41922,41882,41923,43217,6511601,41916",
  PARTICIPATION_MESSAGES = "52223",
  EXCLUDED_APPROVERS = "46234",
  FR_CONTENT_ASSOCIATION = "49831,49830,47424,47526,27006,47415,47417,47423,41980,27008",
  SEND_EMAIL = "46552",
  APPROVAL_REQUIRED = "260005",
  ANNOUNCEMENT_EDITOR = "67147097",
  ADD_EDIT_ANNOUNCEMENT_EDITOR = "42326,550891,550892,41910,41907,41971,45138,41989,67147098,8353701",
  STATE_GUIDELINES = "41843,41844,317005,317004,41847,41848,41841,41842,317001,41845,41969,41846,317002",
  FR_CONTENT_CONFIG = "47423,47817,47425,47805,47806,47801,47817,47426,47804,27101",
  ADD_EDIT_EMAIL_NOTIFICATION_MESSAGES = "41851,41852,41827,85556,85557,525603,525601,525602,525604,525605,37006,37007,85551,46553,85558,41915,80076,85552,85559,85528,80160,48004,80017,41889,80198,85553,42600,40033,85546,85547,85548,85549,85550,85555,378100,8161014",
  MERGEFIELD_MESSAGES = "85560",
  MERGE_FIELD_TABLE_MESSAGES = "85562,85563,85564,85565",
  SPECIALTY_GROUP_MESSAGE = "46570,46571,46572,67147100",
  CONTENT_MANAGEMENT_PERMISSION_SUPPLIER = "130572,130573,47416,47813,41827,130571,130570,130574,130575,130576,130577,130582,130564,130568,130562,130566,130563,130567,130565,130569,130584,130583",
  USER_MANAGEMENT = "44101",
  ADMIN_USER_GROUP = "80160,80161,80162,80163,80164,80165,80166,80167,80168,80169,80170,80172,80173,80174,80175,80177,80180",
  TEXT_MESSAGE_ALERT_MESSAGES = "41851,41852,41827,85500,85501,85528,85502",
  AI_COMPLIANCE_QUEUE = "69112111,69112112",
  SEND_ALERT_CONFIGURATION_MESSAGES = "85506,85509,85520,85521,85522,85513,85515,85516,85517,85518,85519",
  CHANGE_ACTIVITY_DESCRIPTION_MESSAGES = "41817,40133,41819,80131,31838",
  ADD_USER_GROUP_DEVISION_MAPPING_RULE_MESSAGES = "41851,41852,41827,489812,41980,80274",
  AICOMPLIANCEFINDING_EDITOR = "67147097,69112122,47424,49658",
  AICOMPLIANCEFINDING_FLAG_EDITOR = "67147070,67147102,31834,46610,69112123,69112124,659853",
  ADD_USER_GROUP_DEVISION_MAPPING_CONTACT_NOTE = "41960,31834,80203,54519",
  INVITATION_TEMPLATE = "41965,6857511,6857509,49511,49512,80009,80010,80012,80013,80015,80016,80018,80019,31505,80001,80023,31506,6857519,80020,80024,7331903,7331901,7331902,80002,80003,80004,49514,80008,80011,80014,80017,41969,80020,80022,80025,6857510,44132,8161011,8161012,8161013,8161015,9062601",
  GROUPING_CONFIGURATION = "80250,41851,41852,80255,80256,80257,80247,80248,41876,80251,80252,80249,80254,80253",
  REP_EVALUATION_CONFIG = "41851,41852,41827,41960,860150,,860151,860150,67147099",
  USER_MANAGEMENT_ACCOUNTS = "41996,860041,41920,44108,44109,44116,7088020,41979,41978,41980,44104,44105,41988,41973,44106,44107,67147101,41997,860041,44110,44111,44139,44113,44112,42000,41999,41998,41975,41976,130588",
  USER_MANAGEMENT_COMMENTS = "32703,32704,424761",
  USER_MANAGEMENT_MFA_POPUP = "7088016",
  USER_MANAGEMENT_FR_SEARCH_POPUP = "49830,49831,54517,41994",
  USER_MANAGEMENT_SALES_FORCE_INFO_POPUP = "48091,130589",
  USER_MANAGEMENT_ASSIGN_USER_GROUP_POPUP = "41979,41978,41980,5193640,48091,44110,44111,44113,44139,44112,44138,130586,130587,130588,130589",
  USER_MANAGEMENT_PROFILE_TAB = "44111,44113,44139,44112,44138,130586,130587,130588,130589",
  BUDGET_EXEMPTION = "41851,41852,41827,41802,41803",
  ACTIVITY_ASSIGNMENT_MESSAGES = "46584,44532,41807,44533,54402,54401,46537,46524,80264,46526,80245,41978,46531,41935,40023,80271,40036,46530",
  ACTIVITY_ASSIGNMENT_FACULTY_SEARCH_RESULT = "47816,46590,",
  EXPENSE_MANAGEMENT = "41960,41889,41888,41880,41881,41882",
  EXPENSE_APPROVAL_CONFIGURATION = "8126903,8126904,8126905,8126906,8126907,8126908",
  EXPENSE_EXCEPTION_CONFIGURATION = "8126912,8126908",
  ACTIVITY_AUTO_CANCEL_MESSAGES = "10531,10532,41855,41856,42522,42523,80199,80200,80197,80198,17321,48004,41880,49549,80185,80188,80186,80187,80189,80237,41881",
  ADMIN_BUSINESS_JUSTIFICATION_MESSAGES = "10531,10532,80201,80202,80191,80192,80197,40024,41880,41881,49549",
  ACTIVITY_DESCRIPTION_MESSAGECODES = "80246,41851,41852,80111,80132,80072,80074,80073,80058,480680,80076,25196294,25196295,25196296,80059,25196267,80061,7481502,80062,80063,80064,80065,80066,80067,80091,80068,17322,25196278,480689,480690,480691,80069,80071,80070,80098,80077,80078,80080,80079,80082,80083,80084,80085,80086,80087,80060,80088,80241,80242,80243,2699110,2699111,6702004,25196113,25196121,25196114,25196115,25196112,25196116,25196117,25196118,6957511,25196119,25196120,6173801,80094,85544,80089,80090,80097,80099,80244,80204,80205,80100,3524811,25196301,7481501,67147103,67147104,67147105,67147106,67147107,6173804,6173805,6173806,80073,80075,3524810,41827,7453201,8231018,8451101,8451102,8451113,8451121,8492501",
  ACTIVITY_DESCRIPTION_WORKFLOW_MESSAGECODES = "80097",
  HONORARIUM_MANAGEMENT_ADV = "41930,41851,41852,41827,41855,41856,41854,41853,41857,41858,41859,41860,41861,85530,41863,46263,41864,41865,41866,41867,41868,41934",
  FACULTY_SELECTION = "317018,41981,85577,46236,85578,317010,317013",
  ATTENDEE_PROGRAM_BLOCK_MESSAGES = "25196282,41883,41885,41851,41852,41827,41851,41852,41827,41851,41852,41827,41960,41878,41880,41881,41882,41883,41884,41885,25196286,41888,25196290,25196284,41889,25196287,25196292,25196286,25196292,25196286",
  ATTENDEE_PROGRAM_CONTACT_NOTES_MESSAGES = "41960",
  FACULTY_SELECTION_CONTACT_NOTE = "41960",
  TIER_BRAND_MAPPING = "41882,41930,41851,41852,41827,41915,42497,140505,140506,41882,41889,",
  MEDICAL_TIER_ADMIN = "5193618,5193627,5193625,5193619,5193621",
  AICOMPLIANCERULE_CONFIGURATION_EDITOR = "80264,46226,69112125,69112126,69112127,69112131",
  LIST_ACTIVITYRULE_MESSAGES = "140410,41885,41883,41851,41852,41827,80040,41891,41892,46611,67147109,44135,41893,41894,41878,41879,41880,41881,41883,41884,41886,41887,41888,260001,41889,25196300,41890,46611,80179,80203,41959,260003,49232",
  SEARCH_SALES_ORG_RESTRICTIONS_MESSAGES = "44137,44134,41895",
  SEARCH_SALES_ACCESS_TRAINING_MESSAGES = "44137,40303,46258,40304,46612,46612,80043,46613,80042",
  ACTIVITY_RULE_COMMENT_MESSAGES = "41960,46610",
  HONORARIUM_TRAVEL_MESSAGES = "49549",
  ADD_HONORARIUM_TRAVEL_MESSAGES = "49549,41851,41852,41827,67147114,67147110,41880,41881,49549,67147111,67147112,480663,67147113,67147115,67147114,67147116",
  HONORARIUM_ADMIN_MESSAGES = "41930",
  ADD_HONORARIUM_ADMIN_MESSAGES = "85545,80117,85533,85534,85535,85536,85537,85545,85538,85539",
  ADD_HONORARIUM_ADMIN_TIER_MESSAGES = "41851,41852,41827,85531,140505,140506,41882,67147100,85532,52448,",
  HONORARIUM_MANAGEMENT_FDA = "41930,41851,41852,41827,41855,41869,41873,41870,41871,41872,85530,41875,46263,41876,41877,41934",
  HONORARIUM_MANAGEMENT_MEDICAL = "41930,41851,41852,41827,41869,41873,41870,41871,41872,85530,41875,46263,41876,41877,41934",
  PAYMENT_CONFIGURATION = "80117,80129,80133,80182,80184,80119,80120,80121,80122,80123,80207,80208,80209,80210,80126,80128,80183,41851,41852,41827",
  SURVEY_QUESTION_MESSAGES = "7966902,7966903,7966904,7966905,7966906,7966907,7966908,7966909,7966910,7966914,7966915,7966916,7966917,7966918,7966970,41851,41852,7966921,7966942,7966943,67147065,67147066,67147074,67147068,5760304,7966995,7967003,79669108,79669110,79669113,79669115",
  SURVEY_QUESTION_LIST_MESSAGES = "7966901,7966944,7966945,796699901,796699902",
  SURVEY_QUESTION_CONTACT_NOTE = "41960",
  SURVEYBU_LIST_MESSAGES = "7966920,7966940,7966941,7966944,7966918",
  SURVEY_DELETE_TU_REASON_NOTE = "7966986,7966987",
  SURVEYBU_MESSAGES = "41851,41852,7966916,7966917,7966922,7966923,7966924,7966925,7966926,7966927,7966928,7966929,7966930,7966931,7966932,7966933,7966934,7966935,7966936,7966937,7966938,7966939,79669107,79669109,79669114",
  SURVEY_CONFIGURATION_MESSAGES = "41851,41852,7966901,7966916,7966917,7966946,7966947,7966948,7966949,7966954,7966955,7966957,7966959,7966960,7966961,7966962,7966963,7966964,7966965,7966910,7966972,7966973,7966976,7966977,7966978,7966986,7966987,7966988,7966989,7966991,7966992,7966993,80162,7966950,7966944",
  SURVEY_LIST_MESSAGES = "7966945,7966948,7966949",
  SURVEY_AddFRTargetUser_MESSAGES = "7966944,7966950,7966956,7966958,7966994",
  SURVEY_PREVIEW_MESSAGES = "7966979,7966980,7966981",
  CPS_SURVEY_MESSAGES = "7966979,7966980,7966981,7966975,7966974",
  ARF_FORM = "480687,480681,44132,480678,480677,481004,45138,5331025,25196269,130531,480653,480655,480659,480654,480661,480671,480662,480663,480664,480665,480666,480660,480667,480668,480669,480678,480670,480688,480686,480656,480676,8231001,8231002,8231003,8231004,8231005,8231006,8231007,8231008,8231009,8231010,8231011,8231012,8231013,8231014,8231015,8231016,49232,40126",
  ORF_FORM = "67147119,67147120,67147121,67147122,67147123",
  ADD_EXPENSE_DETAIL = "8126911,42001,42002,42003,42004,42005,40133,12009,42524,12010,42011",
  ADD_EDIT_EXPENSE_DETAIL = "42491,48020,42007,42008,42033,42010,42027,42028,42029,42030,42031,42032,41534,46245,130580,22360,41534,80024,67147129,48064,48065,49438,42010,42009,41535,41521,41522,49437,49435,49436,67147108",
  EXPENSE_CORRESPONDENCE = "41601,40133,41603,41602,53003,41604,53002,41605",
  EXPENSE_CORRESPONDENCE_SEND_NOW = "80039",
  ARF_BASIC_SEARCH = "41926,40103,80276",
  ARF_ADVANCE_SEARCH = "40108,40133,50112,40103,50116,50115,40305,50114,50113,50105,50102,40058,46315",
  ACTIVITY_BASIC_SEARCH = "41926,40103,40133,40058,67147133,67147134",
  INVOICE_DETAIL_MESSAGES = "42003,42002,42001,42004,42005,40133,12011",
  ADD_INVOICE_REQUEST_MESSAGES = "41817,40133,42025",
  INVOICE_HISTORY_DETAIL_MESSAGES = "80024,67147130,48063,42019,42020,42018,42024,42023,42021,42026,80112",
  ADD_COMMENT_POPUP_MESSAGES = "32703,32704",
  NOT_CONTRACTED_REASON_MESSAGES = "50103",
  CHECK_STATUS = "525617,67147135,525616,67147177,40255,49831,49830",
  ACTIVITY_MEETING = "48041,25196276,25196281,67147137,25196280,25196275,25196277,67147140",
  ADD_ACTIVITY_MEETING = "860114,42491,48020,48033,42491,48026,48066,48067,48068,25196279,46552,40272,40037,40036,51018,48034,40276,40278,40277,40325,52427,860111",
  ACTIVITY_TOOLS_ACTIVITY_MAP_MESSAGES = "40103,40102,40108",
  ACTIVITY_DIRECTION_MESSAGES = "67147133,67147134",
  SEND_CORRESPONDENCE_MESSAGES = "54521,460091,2699114,85561",
  SEND_CORRESPONDENCE_OVERLAY_MESSAGES = "46552,54542,54543,54544,48083,48084,48082",
  ACTIVITY_CALENDAR_MESSAGES = "67147133,67147134",
  ADD_ADVISING_ACTIVITY_LOCATION_MESSAGES = "130008,130006,130007,860120,5331010,5331011,40026,50106,40272,40274,40273,40038,40276,40278,40277,51018,40325,860113,860111,860112,25196306,130012,67147196",
  ADD_FEEDBACK_ACTIVITY_INFORMATION_MESSAGES = "8834311,67147128,6491101,6491102,6491103,6491105,130008,130006,130007,860120,5331010,5331011,40026,533101,5331024,533109,40075,40319,67147180,40174,40074,533105,40108,46552,40072,40189,40077,40054,10131,25196311,25196312,25196313,25196314,533106,533107,533109,533108,40020,40022,40023,5331021,40181,40497,533105,5331020,860432,5331022,860433,40025,40013,40104,40014,40106,40057,40118,85518,5331019,454011,40021,40157,40158,533103,12183,40067,40068,40069,40072,40206,860421,5331028,300,5331029,40070,5331030,40071,40062,40063,40160,40077,40189,40131,48058,40154,40047,40078,40064,40234,44114,40065,40052,40066,40037,40036,48066,48067,48068,25196279,46552,130003,130012,40137,40220,40221,40228,40080",
  ADD_FEEDBACK_ACTIVITY_ADVISORY_DESCRIPTION_MESSAGES = "40010,40119,40120,41531,40011,40012,40235,40125,40126,40127,40128,40129,40130,40236,40237,130012,20122",
  ADD_ADVISING_ACTIVITY_PARTICIPATION_INFO_MESSAGES = "25196276,25196275,25196277,25196281,25196304,25196305,67147191,6736802,67147137,67147140,40111,40061,40006,40003,40004,40005,40007,40008,40310,40094,40142,40141,40114,40115,40287,40283,67147190,40265,40258,40259,40281,25196280,25196275,860408,454020,40137,40143,40144",
  ADD_OUS_BASED_HCP_INFO_MESSAGES = "130001,40701,40700,40702,40703,40704,40257,40211",
  ADD_NON_HCP_INFO_MESSAGES = "130002,40701,40700,40702,40703,40704,40257,40211,40709,40705,40707,40706,40708",
  ADD_NON_MEDICAL_PERSONAL_MESSAGES = "860117,10733,40280",
  FEEDBACK_FILE_UPLOAD_MESSAGES = "12783,67151006,67151001",
  ADD_ADVISING_ACTIVITY_COMMENTS_MESSAGES = "32704,32703,25196309",
  ADD_ACTIVITY_MESSAGES = "40178",
  ACTIVITY_PAYMENT_REQUEST = "42414,42609,41521,41522,40255,49831,49830,31501,31503,41529,31504,41530,40482,31507,860122,6736804,6736805,41501,41523",
  ACTIVITY_PAYMENT_REQUEST_ADVISING_HONORARIUM = "41502,41503,41504,41505,40310,41507,41508,41510,41511,41512,41513,41514,41515,41516,67147139",
  ACTIVITY_PAYMENT_REQUEST_RELATED_ACTIVITIES = "860122,67147141,67147142,67147143,67147144,67147198,67147199,860110,855585,40108,40133,50112,50116,40305,50114,50113,50105,50102,860110,6736801",
  PRESENTER_MODERATOR_DIALOG = "41526,41527,41528",
  ACTIVITY_MESSAGES = "20003,32703,32704,32705,40178,53040,860136",
  MEDICAL_ACTIVITY_MESSAGES = "8854301,8854303,8854304,12023,12025,12035,12183,40303,40304,42334,42491,46264,46272,46273,46307,48020,48052,48047,49656,49657,49802,49809,49650,49658,48079,41970,42491,47816,48004,48048,48051,48005,48006,48028,48029,48031,48032,48049,48051,48031,48032,52770,860120,130027,5273703,5273704,67147148,67147153,7088016,48050,48040,10534,48057,48056,41536",
  BUDGET_APPROVER_INFO_MESSAGES = "860120,40077,40189,48050,40054,48039,40154,48039,48048,40131,42491,48058,40047,40054,70011",
  CANCEL_ACTIVITY = "47725,47726,10324,47732",
  MULTIPLE_ACTIVITIES = "10029,40135,40134,40136",
  FIELD_ACTIVITY_INFO = "40026,40022,40025,80034,40081,80196,48089,40022,860439,40023,40024,40020,48088,40031,40093,48086,48087,80195,40085,40082,40083,40084,40032,10460,67147149,48066,48067,48068,48093",
  FIELD_ACTIVITY_DATE_AND_TIME = "40108,40220,40221,40228,40294,80054,80055,40146,396061,40013,40014,40013,40057,80028,40042,80050,80030,40044,80052,80031,40015,40105,40017,40107,40043,80051,40045,80053",
  FIELD_ACTIVITY_LOCATION = "8451118,8451123,8451124,8451125,8451126,8451109,8451108,8451107,40033,860114,40034,50106,251983,40233,48071,80036,48072,48073,48074,48075,40037,40036,48093,40038,51018,855591,860113,860111,860112,40474",
  FIELD_ACTIVITY_PID_DISTRIBUTION_DIALOG = "48090,48092",
  FIELD_ACTIVITY_ADD_REPRESENTATIVE_DIALOG = "10733,10734,40303,40304,67147150,44215",
  ADD_EDIT_HCP_REGISTRATION_ADMIN_MESSAGES = "590025,590026,590028,590021,590023,600115",
  FIELD_ACTIVITY_REPRESENTATIVE = "67147184,8451130,40226,40054,40224,40223,40139,67147151,10131,67147151,67147101,67147152,40048,48076,48078,41996",
  FIELD_ACTIVITY_UPDATE_LEAD_REPRESENTATIVE_CELL_PHONE = "70501,48070,70502,42499",
  FIELD_ACTIVITY_UPDATE_LEAD_REPRESENTATIVE_FACETIME = "70505,70506,70504",
  FIELD_ACTIVITY_AUDIENCE = "40124,40123,40309,40089,40092",
  FIELD_ACTIVITY_TRAVEL = "44381",
  SEARCH_FACULTY_MESSAGES = "40144,40001,49831,49830,40002,40003,40004,40005,40006,40094,40007,40008,40009,40310,25196262,25196263,40148,40147,40255,40133,40111,40257,40061,40142,40141,40114,40115,40143,130016,67147156,42507,40145",
  FIELD_ACTIVITY_PROGRAM_VALIDATION = "130010,40216,40219,130018,25196126,25196127",
  FIELD_ACTIVITY_FACULTY = "44415,40117,67147154,8451114,25196275,25196276,25196281,25196277,67147137,67147140,25196280,40151,40474,317016",
  ACTIVITY_UPLOAD_RECEIPT = "251956,12785,251986",
  WRITE_IN_MESSAGES = "251947,251954,251955,251943,42491,48020,538473,67147162,49830,67147163,49831,40305,42490,251960,49658,251971,251969,251970,251963,251964,251965,251966,49650,8854303,480681",
  ACTIVITY_TERRITORY_MESSAGES = "251988,251989,251941,49830,49831,40305,251960,251961,54518,25196256,25196258,460092,25196132,251959",
  ACTIVITY_NEW_AUDIENCE = "67147158,67147169,40309,40089,251985,40092,67147167,67147165,67147166,25196260,860446,25196128,25196129,25196130,25196131,251958,251977,251978,251946,472271,44115,25196111,251984,251986,251953,40124,40123,41827,25196310",
  ACTIVITY_UPLOAD_INVITEE = "25196250,25196252,251956,25196251",
  UPLOAD_SIGN_IN_SHEET = "251952,251956,251957,251950",
  PROGRAM_MATERIAL = "40700,40701,54503,40702,40705,40711,41988,46552,13106,67147168,67147165",
  UPLOAD_MEETING_MATERIAL = "6173809,251952,251956,6173810,251950",
  PROGRAM_CLOSE_OUT_AUDIENCE = "67147172,251993,251992,,25196127",
  ATENDEE_LIST_DIALOG_MESSAGES = "25196128,25196129,251977,251978,251958,25196260,25196111,,25196130,25196131,251946,251953,251986,251985",
  PROGRAM_CLOSE_OUT = "40474,40222",
  BRAND_ACTIVITY_INFO = "40026,6491105,6491102,6491101,6491103,10486,67147180,40074,40075,40220,40221,40228,40108,40025,80034,40013,40081,48089,40023,860439,40014,40057,40093,40082,40084,40083,40081,40085,48066,48067,48068,25196279,46552,48088,48087,48086,40032,6491104,40474,85518,40020,40021,40321,40015,40105,40017,40107",
  BRAND_ACTIVITY_ADVISORY_DESCRIPTION = "40010,40119,40120,40125,40126,40011,40127,40128,40012,40129,40130,40235,40236,40237,40474",
  BRAND_ACTIVITY_FINANCE = "40474,40054,10131,40131,40062,40063,48058,40154,40047,40078,67147182,67147189",
  TOPICS_AND_TRAININGS_MESSAGES = "40124,40123",
  ACTIVITY_FIELD_COMMENTS = "40474,67147166,32703,32704,40220,40146,40145,10042,10041,130013,130012,40137,67147170",
  PROGRAM_CLOSE_OUT_FINANCIAL = "6173812,12784,67147174,6173814,25196126,25196127,67147173",
  MEETING_COST_INFO = "40193,40196,40194",
  ACTIVITY_SPONSOR_CONTACT = "40072,860120,40067,40068,40069,300,40070,40071,40474",
  OPTIN_TRAVEL_PREFRENCE = "8834301, 8834309",
  ADD_LINKED_ACTIVITIES_MESSAGES = "860110,855585,40108,40133,6736801",
}

export enum CPSConstants {
  FONT_FAMILY = "Montserrat",
  IVALID_DATE = "0001-01-01T00:00:00",
  CPS_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS",
  CPS_DAY_MONTH_YEAR_TIME = "dd/MM/yyyy hh:mm:ss aa",
  CPS_MONTH_DAY_YEAR_TIME = "MM/DD/YYYY hh:mm:ss A",
  CPS_MONTH_DAY_YEAR_HH_MM_TIME = "MM/DD/YYYY hh:mm A",
  CPS_MONTH_DAY_YEAR_HH_MM_SS_AMPM = "MM/dd/yyyy hh:mm:ss aa",
  MONTH_DAY_YEAR_TIME = "MM/dd/yyyy hh:mm a",
  MONTH_DAY_YEAR_COMMA_TIME = "MM/dd/yyyy, hh:mm a",
  CPS_MONTH_SLASH_DAY_YEAR = "M/dd/yyyy",
  MUI_STACK_LOGINFORM_SPACE = 0.1,
  SUCCESSMESSAGE_EIGHTSIXFOURFIVE = 860045,
  SUCCESS_MESSAGE_CODE = 0,
  FIVEHUNDRED = 500,
  MIN_LENGTH_THIRTY_FIVE = 35,
  MAX_LENGTH_TWO_FOURTY = 240,
  MAX_LENGTH_TWO_FIFTY = 250,
  MAX_LENGTH_TWENTY_FIVE = 25,
  TEXT_ROW = 4,
  MAX_LENGTH_TWO = 2,
  MAX_LENGTH_ONE_FIFTY = 150,
  MAX_LENGTH_HUNDRED = 100,
  MAX_LENGTH_ONEHUNDREDTWENTY = 120,
  MAX_LENGTH_TWO_HUNDRED = 200,
  MAX_LENGTH_SIX = 6,
  MAX_LENGTH_SEVEN = 7,
  MAX_LENGTH_EIGHT = 8,
  MAX_LENGTH_THIRTY_FIVE = 35,
  MAX_LENGTH_THOUSAND = 1000,
  MAX_LENGTH_FOURTY = 40,
  MAX_LENGTH_THREE_HUNDRED = 300,
  MAX_LENGTH_TWO_HUNDRED_FIFTY = 250,
  MAX_LENGTH_THREE_HUNDRED_FIFTY = 350,
  MAX_LENGTH_US_TELEPHONE = 14,
  MUI_TEXTFIELD_SIZE = 9,
  MSG_SET_TIMEOUT = 10000,
  MUI_OTPSCREEN_SIZE = 11,
  MAX_LENGTH_FIVE = 5,
  MAX_LENGTH_FOUR = 4,
  MAX_LENGTH_THREE = 3,
  MAX_LENGTH_TWELEVE = 12,
  MAX_LENGTH_FOURTEEN = 14,
  MAX_LENGTH_FIFTHTEEN = 15,
  MAX_LENGTH_TWENTY = 20,
  MAX_LENGTH_THIRTY = 30,
  MAX_LENGTH_THIRTYFIVE = 35,
  MAX_LENGTH_FIFTY = 50,
  MAX_LENGTH_TWENTY_NINE = 29,
  MAX_LENGTH_TWENTY_SIX = 26,
  MAX_LENGTH_FORTY_FIVE = 45,
  MAX_LENGTH_FIFTY_ONE = 51,
  MAX_LENGTH_TEN = 10,
  MAX_LENGTH_NINE = 9,
  MAX_LENGTH_FIVE_HUNDRED = 500,
  MAX_LENGTH_FIFTEEN_HUNDRED = 1500,
  MAX_LENGTH_FOUR_THOUSAND = 4000,
  MAX_LENGTH_ONE_THOUSAND = 1000,
  MAX_LENGTH_SIX_HUNDRED = 600,
  MAX_LENGTH_THREE_THOUSAND = 3000,
  MAX_LENGTH_TWO_THOUSAND = 2000,
  MAX_LENGTH_FIVE_HUNDRED_TWELVE = 512,
  MAX_LENGTH_ELEVEN = 11,
  MAX_LENGTH_THIRTEEN = 13,
  MAX_LENGTH_TWO_HUNDRED_FIFTYFIVE = 255,
  MAX_LENGTH_SEVENTYFIVE = 75,
  FACULTY_CONTACT_NOTE_CONTENT_LIMIT = 100000,
  FORM_ROW_SPACING = 3,
  FORM_COLUMN_SPACING = 2.5,
  CPS_TL_CRM_REPORT = 307,
  DEFAULT_COLUMN_SORT = "product",
  GRID_ROW_HEIGHT = 25,
  LARGEST_MEETING_ROOMS_CONSTANT = 99999,
  APPROVAL_ALERT_ID = 37,
  PLEASESELECTPROFILE = "Select Profile",
  PLEASE_SELECT = "Please select",
  UNAUTH_QUERY_STRING = "/login?logoutcase=1",
  UNAUTH_QUERY_STRING_LOGOUT_SYSTEM = "/login?logoutcase=2",
  UNAUTH_QUERY_STRING_SESSION = "/login?logoutcase=3",
  GOOGLERECPATCHAWHEN = "gReCaptchaResponse",
  PW_ONLY = "pwonly",
  MAX_FACULTY_KEY = "2147483647",
  FORMHEADERLOGOWIDTH = "34rem",
  FORMBGCOLOR = "#FFFFFF",
  BGHEIGHT = "100vh",
  LOGINFORMBORDERRADIUS = "0.5rem",
  LOGINFORMWIDTH = "375px",
  LOGINFORMHEIGHT = "38rem",
  LOGINSECONDFORMHEIGHT = "4.5rem",
  FORMWIDTH = "375px",
  STANDARDCOLOR = "#040D36",
  BUTTONBGCOLOR = "#275dc6",
  FONTWEIGHT = "500",
  FONTREMTITLE = "1.5rem",
  FONTREMHEAD = "1.2rem",
  FONTREMTEXT = "1rem",
  DEFAULTCOUNTRYCODE = 1,
  COLUMN_HEADER_NAME_ACTIONS = "Actions",
  COLUMN_HEADER_NAME_ACTION = "Action",
  UPTOTWOFIFTYCHARS = "Business justification minimum 35 characters and up to 250 characters.",
  APPENDVIEWOWNERSHIP = "alerts/orfalertsubmitterstatus",
  MAX_THOUSAND_CHARACTER = "max 1000 characters allowed",
  MAILING_1099_TOOLTIP = "1099 Mailing indicator is available, when a W9 address is added. When checked for any address type, it will use that physical address to print and mail the 1099 form.",
  QUICK_INFO = "QuickInfo",
  FDA_REGULATED = "FDA-Regulated",
  TYPEOF_STRING = "string",
  // Reports module
  PAGE = 0,
  PAGE_SIZE = 10,
  ALERT_TYPE = "DMC Compliance Alert",
  BUDGET_APPROVE_TITLE = "Budget Approval Reason",
  UNDER_REVIEW_RECORD = "Under Review Record",
  APPROVE_TITLE = "Approval Reason",
  APPROVE_DESCRIPTION = "Enter reason for Approving the alert",
  APPROVE_DESCRIPTION_OPTIONAL = "Enter reason for approving. (Note: Reason for approval is optional)",
  DENYING_ALERT = "Enter reason for Denying the alert",
  FACULTY_SCREEN_ALERT = "Faculty Screening Alerts",
  DENY_TITLE = "Denial Reason",
  DENY_DESCRIPTION = "Enter reason for denying the approval",
  ONHOLD_TITLE = "Holding Reason",
  ONHOLD_DESCRIPTION = "Enter reason for Holding the alert",
  SMALL_ALL = "all",
  CAPS_ALL = "All",
  CAPS_ADD = "ADD",
  CAPS_TRIGGERPPQ = "TRIGGERPPQ",
  ADD = "add",
  EDIT = "edit",
  FORM_TEXT = "form",
  OPEN_TEXT = "open",
  BACKDROPCLICK = "backdropClick",
  APPROVER_1 = "Approver 1",
  APPROVER_2 = "Approver 2",
  CHAR_LIMIT_TO_REASON = 20,
  CHARACTER_LIMIT = 20,
  ACTIVITY_TYPE_ID = 3,
  ALERT_TYPE_ID = 10568,
  NONHCP_SUBMENU_ID = 2230,
  PATIENT_AND_CAREGIVER_SUBMENU_ID = 2229,
  PATIENT_AND_CAREGIVER_SUBMENU = "Add Patient/Caregiver",
  NONHCP_SUBMENU = "Add Non-HCP",
  PATIENT_EDIT_CAREGIVER_SUBMENU = "Edit Patient/Caregiver",
  NONHCP_EDIT_SUBMENU = "Edit Non-HCP",
  PATIENT_AND_CAREGIVER_SUBMENU_TEXT = "Patient/Caregiver",
  NONHCP_SUBMENU_TEXT = "Non-HCP",
  TEXTAREA_ROW_COLUMN = 3,
  TEXTAREA_MIN_ROW_COLUMN = 2,
  FACULTY_ADD_CONFIRMATION_TEXT = "Are you sure you want to continue with the request to add faculty?",
  ADD_MULTIPLE_FACULTY_TIP_TEXT = "Tip: Row #1 of the spreadsheet (in green below) displays the names of the fields for you to enter",
  FILE_NAME = "MultipleFacultyRequest.xlsx",
  BROWSE_IMPORT_FILE_TEXT = "Browse And Import The File Into CPS System",
  HOME = "Home",
  APPROVERS = "Approvers",
  DOWNLOAD_SPREADSHEET = "Download Spreadsheet",
  ADD_MULTIPLE_FACULTY = "Add Multiple Faculty",
  POPUP = "popup",
  POPUP_DIRECT = "direct",
  GENERAL_PROFILE_HEADING = "General Profile",
  FACULTY = "faculty",
  PROFILE = "profile",
  FIELDNAME = "[FieldName]",
  CONFERENCE_DIAL_NUMBER = "Conference Dial-In Number",
  THIS_INFORMATION_REQUIRED = "This information is required.",
  VALID_EMAIL_REQUIRED = "Please enter valid email address.",
  VALID_CONTACT_NUMBER_REQUIRED = "Please enter valid contact number.",
  VALID_DATE_REQUIRED = "Please enter valid date.",
  DELETE = "delete",
  SYNCFUSIONREQUESTTYPE = "ContentLoaded",
  SCHEDULED = "scheduled",
  OCCURED = "occurred",
  TOTAL = "total",
  CANCELLED = "cancelled",
  PUBLISH = "Publish",
  TAXFORMDELETE = "Delete",
  DATEFORMAT = "MM/dd/yyyy",
  DATEWITHTIMEFORMAT = "M/D/YYYY h:mm A",
  ITEM_HEIGHT = 48,
  ITEM_PADDING_TOP = 8,
  CAPS_REMOVE = "REMOVE",
  PROFILE_DATA_VERIFICATION_TEXT = "<p><b>Off:</b> The manual override is not applicable; the Faculty will be included in the Data Verification process once they have met the verification criteria.<br><br><b>Exclude from the process:</b> The DV overlay will not display for this Faculty. Change back to 'Off' to remove the exclusion and start the process when the necessary criteria are met.<br><br><b>Trigger Data Verification:</b> Force the DV to display regardless of the Faculty meeting the necessary criteria. The DV will apply for the current calendar year only. The trigger is then removed starting January 1st.</p>",
  SUPRESS_EMAIL_NOTIFICATION = "This individual will not be copied on any applicable system-generated emails to the faculty.",
  FACULTY_DATA_VERIFICATION_CRITERIA = "Faculty Data Verification Criteria",
  FACULTY_DATA_VERIFICATION_BLOCK1 = "The following settings and criteria are considered to have the Faculty Data Verification overlay screens shown to the faculty member when they either log on to the FR website or FR App.",
  FACULTY_DATA_VERIFICATION_BLOCK2_1 = "1. Set a start date in the system metadata to kick off the process",
  FACULTY_DATA_VERIFICATION_BLOCK2_2 = "2. When the faculty member logs in to the system, and if one or more of the eligibility criteria below is met",
  FACULTY_DATA_VERIFICATION_CRITERIA1 = "New Faculty added in that current calendar year via the Faculty > Add Faculty after Sponsor 1 & 2 approves, and the faculty status is 'Restricted To Be Screened'.",
  FACULTY_DATA_VERIFICATION_CRITERIA2 = "New Faculty is added in that <b>current calendar<b> year via the Faculty tab (Medical) after the faculty key is associated with the profile.",
  FACULTY_DATA_VERIFICATION_CRITERIA3 = "When CPP ownership is set for a faculty member as 'Selected' = Yes + Current <b>OR</b> Future Year.",
  FACULTY_DATA_VERIFICATION_CRITERIA4 = "When the <b>New/Existing Faculty is added in Medical Activity</b> having below:",
  FACULTY_DATA_VERIFICATION_CRITERIA5 = "1. Activity Status: Pending or Active <br /> 2. A contract with an end date that is after the Data Verification start date <br /> 3. With a Consultant Status:",
  FACULTY_DATA_VERIFICATION_CRITERIA6 = "Approved <br /> Pending Milestone Approval <br />Agreement/Amendment Sent <br />Fully Executed <br /> Pending Deviation <br />Pending Budget Approval <br /> Pending Screening<br />CV not received<br />CV received in review<br />Screening Under Review",
  ADD_EDIT_EXPENSE_DIALOG_TITLE = "Add/Edit Expense Exception",
  ADD_EDIT_SB_INDICATOR_DIALOG_TITLE = "Add/Edit SB Indicator/ Brand Rule",
  ADD_ORGANISATIONAL_CONTACTS = "Request to Add Organizational Contact",
  EDIT_PPQ_TITLE = "Edit PPQ",
  FACULTY_INTRODUCTORY_VIDEO_LABEL = "External viewers can access the introductory video by scanning the QR code found on printed and emailed invitations to faculty-led, brand-approved activities",
  FACULTY_INTRODUCTORY_SEND_TOOLTIP = "By clicking ‘Send,’ the system checks if the faculty member qualifies. If so, an email alert is sent, and alerts appear on the FR website under 'My Actions' and in the FR App under 'Pending Action Items.' The alert includes a link to Spokenote for video recording.",
  FACULTY_INTRODUCTORY_OPTOUT_TOOLTIP = "Opt-out from the introductory video recording by selecting this option. Re-enabled at any time by deselecting this option.",
  NO_PDF_FOUND = "No PDF Found",
  SAVE = "Save",
  FILTER_REQUESTER = "Requester",
  ASSOCIATE = "Associate",
  LEADER = "Leader",
  FACULTY_DATA_VERIFICATION = "Faculty Data Verification",
  HERE = " here ",
  NOTE = "Indicates that a field allocation exists within the brand allocation rule.",
  NOTE1 = "Indicates that there is a sub-allocation exists within the brand allocation rule.",
  DOWNLOAD_EXCEL_HOVER_TEXT = "This will download a spreadsheet that shows the faculty’s detailed compensation.  It will show all funds that are used, available, and allocated by brand, as well as allocations that are made for specific Divisions/Districts/Areas/Sales Representatives",
  VEEVA_WEBSITE_LINK = "http://veevanetwork.lilly.com",
  ENTERPRISE_WEBSITE_LINK = "https://ecs.lilly.com",
  CONTACT_POPUP_TITLE = "View Contact Notes",
  BI_COMP_LIMIT_POPUP_TITLE = "BI - Lilly Alliance Compensation & Utilization",
  FDA_ALLOCATION_RULE_DIALOG_TITLE = "Add /Edit FDA Regulated Allocation Rule",
  ALLOCATION_DELETE_MESSAGE = "Do you want to inactivate the rule?",
  ALLOCATION_BREAKDOWN_DIALOG_TITLE = "Allocation Breakdown - ",
  ALLOCATION_BREAKDOWN_AVAILABLE = "Available Amount",
  ALLOCATION_BREAKDOWN_ALLOCATED = "Allocated Amount",
  ALLOCATION_BREAKDOWN_USED = "Used Amount",
  ALIGNMENT_RULES_DIALOG_TITLE = "Alignment Rules",
  FACULTY_VIDEO_CRITERIA_LABEL = "On $date$, the faculty introductory video email was initiated. However, regardless of opting back in or sending the alert, the faculty member does not yet meet the criteria for the Introductory Video email alert. Once the criteria are fulfilled, the system will send the email with instructions.",
  FACULTY_REQUEST_PROFILE = "facultyrequestprofile",
  REQUEST_FOR_FUNDS_TITLE = "Request For Funds",
  FILE_NOT_EXIST = "File not exist",
  NO_CREDENTIALS = "No Credentials",
  OCCURRED = "Occurred",
  ACTIVITYSATS_CANCELLED = "Cancelled",
  N_A = "N/A",
  ADDORG_CONTACT_DIALOG = "Thought Leader Relationship Contact",
  VIEW_CV_TITLE = "View CV",
  VIEW_BIO_TITLE = "View Bio",
  VIEW_PICTURE = "View Picture",
  CV_NOT_AVAILABLE = "CV not available",
  BIO_NOT_AVAILABLE = "Bio not available",
  CHANGEPASSWORDFROMEMAIL = "ChangePasswordFromEmail",
  PICTURE_NOT_AVAILABLE = "Picture not available",
  NOT_AVAILABLE = "Not Available",
  ADMIN_SUBMENU_TEXT = "Admin:",
  EMPTY_HTML = "<p><br></p>",
  AFFILIATE_LIST_STATUS = "0,1",
  AMERICA_NEW_YORK_TIMEZONE = "America/New_York",
  UPDATE_APPROVERS = "Update Approvers",
  APPROVER_FROM = "approverFrom",
  APPROVER_TO = "approverTo",
  MEDICAL_APPROVER_FROM = "medicalApproverFrom",
  DAILY_FREQUENCY_LABEL_REPORT_SCHEDULER = "This report will be generated every weekday and it will be emailed to the email address on file.",
  WEEKLY_FREQUENCY_LABEL_REPORT_SCHEDULER = "This report will be generated on $selectedDays$ of every week and it will be emailed to the email address on file.",
  MONTHLY_FREQUENCY_LABEL_REPORT_SCHEDULER = "This report will be generated on $selectedDays$ and it will be emailed to the email address on file.",
  DAY_OF_MONTHLY_LABEL_REPORT_SCHEDULER = "$day$ of every month",
  REPORTSCHEDULERCONSTANTS = "ReportSchedulerConstants",
  DAILY = "Daily",
  WEEKLY = "Weekly",
  MONTHLY = "Monthly",
  MEDICAL_APPROVER_TO = "medicalApproverTo",
  LEGAL_APPROVER_FROM = "legalApproverFrom",
  LEGAL_APPROVER_TO = "legalApproverTo",
  REGULATORY_APPROVER_FROM = "regulatoryApproverFrom",
  REGULATORY_APPROVER_TO = "regulatoryApproverTo",
  UPDATE_LEVELS = "updateLevels",
  BRANDS_ON_CONTRACT = "Brands on the Contract",
  CONTRACT_DEFINITION = "Contract Definition",
  ADD_TITLE = "Add",
  REMOVE_TITLE = "Remove",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  CAMELCASE_INACTIVE = "InActive",
  MAX_THREE_FIFTY_CHARACTER = "350 character limit",
  ALIGNMENT_LIMITS_POPUP_MSG = "The Rule for the same combination already exists. Do you want to update the existing rule?",
  FR_COORDINATOR_FACULTY_REQUEST_ALERT = 130,
  FIRST_AFTER_IMMEDIATE = 1,
  MAX_HUNDERD_CHARACTER = "(Note cannot exceed 100 characters)",
  CLIENT = "client",
  ADD_ARROWS_BUTTON_TEXT = "Add >>",
  REMOVE_ARROWS_BUTTON_TEXT = "<< Remove",
  PREVIEW = "Preview",
  BACK = "Back",
  YEAR_MONTH_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS",
  AUTOMATED_BUSINESS_TASK_SELECT_VALIDATION_MESSAGE = "Please select ",
  AUTOMATED_BUSINESS_TASK_ENTER_VALIDATION_MESSAGE = "Please enter the ",
  ATTACHMENT = "Attachment",
  LOGO = "Logo",
  TABLE_MERGE_FIELD_EXIST = " is already added.",
  Place_Holder_Text = "Please Select",
  MONTH_DATE_YEAR_FORMAT_WITHOUT_TIME = "MM/DD/YYYY",
  YEAR_MONTH_DATE_FORMAT_WITHOUT_TIME = "YYYY-MM-DD",
  AM = "AM",
  PM = "PM",
  ARROW_DOWN = "ArrowDown",
  ARROW_UP = "ArrowUp",
  CONTENT_MANGEMENT_PARENT_CPS = "CPS",
  CONTENT_MANGEMENT_PARENT_CPP = "CPP",
  CONTENT_MANGEMENT_PARENT_FR_RESOURCES = "FR - Resources",
  CONTENT_MANGEMENT_PARENT_FR_CONTENT = "FR - Content",
  ACTIVITY_DESCRIPTION_PARAMS = "activitydescription",
  ACTIVITY_POPUP_MESSAGE = "Are you sure this Activity Blocking Rule should be an Overarching Rule?",
  TIME_FORMAT = "HH:mm:ss.SSS",
  CPS_DATE_API_FORMAT = "YYYY-MM-DD'T'HH:mm:ss.SSS",
  MULTI_SELECT_ITEM_HEIGHT = 40,
  MULTI_SELECT_VISIBLE_ITEMS = 4,
  RESET = "Reset",
  CAPS_UP = "UP",
  CAPS_DOWN = "DOWN",
  CPS_LILLY_ACTIVITY_OWNER = "cpsLillyActivityOwner",
  BUDGET_DIRECTOR = "budgetDirector",
  REQUEST_FORM_DELETE_MESSAGE = "By clicking the Yes button, the Attachment will be deleted permanently. Do you want to confirm?",
  REQUEST_FORM_SAVE_AS_DRAFT_MESSAGE = "By clicking the save button, the ARF will be saved as a draft.",
  L2Approver = "L2Approver",
  ADMIN_TOPIC_TRAINING_FILE_CHANGE_CONFIRMATION = "Are you sure you want to replace this file?",
  SurveyDeclined = 36,
  PLEASE_LIST = "other (please list)",
  OTHER = "other",
  DELETE_SUB_QUESTION = "Delete Sub Question",
  ALERT_PAGE = "Alert",
  STATUS_CLOSED = "Closed",
  STATUS_ACTIVE = "Active",
  CPS_WEBSITE = "CPS website",
  MAX_FILE_SIZE_10MB_IN_BYTES = 10485760,
  PLEASE_SELECT_ID = -1,
  FACULTIES = "Faculties",
  CLOSE = "Close",
  CANCEL = "Cancel",
  CPS_DATE_MM_DD_YY = "MM/dd/yy",
  DIRECTIONS_URL = "/activity/activitydirectionsearch",
  TEXTAREA_TEN_ROW_COLUMN = 10,
  MAX_FACULTY_KEY_Number = 2147483647,
  PAYMENT_REQUEST = "paymentRequests",
  FACULTIES_STRING = "faculties",
  CONFIRMATION_RELATED_ACTIVITY_TEXT = "Please note there is an activity selected for which travel has already been associated. Are you sure you would like to proceed ? ",
  Advising_Honorarium_Dialog_title = "Advising Honorarium (Values will not update until the submit button is clicked below and also on Payment Request Page)",
  BUDGET_APPROVER_INFO_RELOAD_CONFIRMATION_MESSAGE = "Activity information has been updated by some other user. Please confirm whether you need to reload the activity information.",
  YEAR_MONTH_DATE_FORMAT_WITHOUT_MILI_SEC = "YYYY-MM-DDTHH:mm:ss",
  CPS_YEAR_MONTH_DAY = "YYYY/MM/DD",
  SEG_DESC_TOP = "Top",
  SEG_DESC_BOTTOM = "Bottom",
  CVENT_MEETING = "CVent Meeting",
  APPENDEXPENSEAPPROVALREQUESTS_URL = "activity/expensemanagement?isFromDashboard=true",
}

export enum GridNoRowsMessages {
  GRID_NO_MYLISTS_MSG = "There are no My Lists.",
  GRID_NO_ADDRESS_MSG = "There are no Address Type.",
  GRID_NO_ADDITIONAL_REQUESTOR_MSG = "There are no Addditional Requesters.",
  GRID_NO_QUESTIONNAIRE = "There are no Questionnaire.",
  GRID_NO_FACULITIES_MSG = "There are no Faculties.",
  GRID_NO_EXPENSE_EXCEPTIONS_MSG = "There are no Expense Exceptions.",
  GRID_NO_FACULTY_INTRODUCTORY_VIDEO_MSG = "There are no Faculty Introductory Video.",
  GRID_NO_FACULTY_Rules_MSG = "There are no Faculty Rules.",
  GRID_NO_DELEGATES_MSG = "There are no Delegates.",
  GRID_NO_CUSTOMER_MEETING_MSG = "There are no Customer Meeting Services Associate.",
  GRID_NO_THOUGHT_LEADER_MSG = "There are no Thought Leader Relationship Contact.",
  GRID_NO_ACTIVITY_STASISTICS = "There are no Activity Statistics.",
  GRID_NO_CONTRACTS_TRAINING = "There are no Contracts/Training.",
  GRID_NO_BRAND_TOPICS = "There are no Brand/Topics.",
  GRID_NO_TOPIC_INFO = "There are no Topic Info.",
  GRID_NO_POTENTIAL_CONFLICTS = "There are no Potential Scheduling Conflicts.",
  GRID_NO_ACTIVITIES = "There are no Activities.",
  GRID_NO_TAXFORM = "There are no Tax Forms.",
  GRID_NO_CONTACT_NOTES = "There are no Contact Notes.",
  GRID_NO_AFFILIATION = "There are no Affiliations.",
  GRID_NO_HCP_AFFILIATION = "There are no HCP Affiliation(s).",
  GRID_NO_VENUE_CATERER = "There are no Venue/Caterer.",
  GRID_NO_OPTIN_TRAVEL_DOCUMENT = "There are no Travel Documents.",

  GRID_NO_METADATA = "There are no Metadata details.",
  GRID_NO_AFFILIATION_MSG = "There are no Affiliation Lists.",
  GRID_NO_COMPLIANCE_QUEUE_MSG = "There are no Compliance Queue Lists.",
  GRID_NO_COMPLIANCE_RULES_MSG = "There are no Compliance Rule Lists.",
  GRID_NO_MEDICAL_DD_MSG = "There are no Medical DD Fields Lists.",
  GRID_NO_SUPPLIER_MSG = "There are no Supplier Lists.",
  GRID_NO_ENTITY_MSG = "There are no Entity Lists.",
  GRID_NO_HCP_MSG = "There are no HCP Lists.",
  GRID_NO_1099_INDIVIDUAL_MSG = "No records were found to Generate 1099 Individual Report.",
  GRID_NO_1099_CONTACT_NOTES = "There are Contact Notes.",
  GRID_NO_SUPPLIER_BRAND_RULE = "There are no Supplier Brand Rules.",
  GRID_NO_SUPPLIER_MAPPING = "There are no Supplier Mapping Lists.",
  GRID_NO_VMS_FACULTY = "There are no VMS Faculty Lists.",
  GRID_NO_ANNOUNCEMENT_EDITOR = "There are no Announcement Editor Lists.",
  GRID_NO_FIELD_LIST = "There are no Field Lists.",
  GRID_NO_BRAND_APPROVERS = "There are no Approvers List.",
  GRID_NO_SPONSOR_ASSIGNMENT_RULE = "There are no Sponsor Assignment Rule List.",
  GRID_NO_SPEAKER_PROGRAM_COMMENTS = "There are no Speaker Program Preferences Comments List.",
  GRID_NO_SPEAKER_PROGRAM_NOTIFICATION = "There are no Speaker Program Preferences Notification List.",
  GRID_NO_BRANDS = "There are no Brands List.",
  GRID_NO_SUB_BRANDS = "There are no SubBrands List.",
  GRID_NO_ANNUAL_CONFIG = "There are no Annual Config List.",
  GRID_NO_ACTIVITY_COST_CENTER_RULES = "There are no Activity Cost Center Rules List.",
  GRID_NO_TOPIC_CONFIG = "There are no Topics/Training Requirements Config List.",
  GRID_NO_FACULTY = "There are no Faculties List.",
  GRID_NO_ACTIVITY = "There are no Activities List.",
  GRID_NO_USERS = "There are no Users List.",
  GRID_NO_ADVISING_CENTRAL_MEMBERS = "There are no Advising Central Members Configuration comments.",
  GRID_NO_COMMENTS = "There are no Credentials for Payment Limits Comments.",
  GRID_NO_ACTIVITY_ASSIGNMENTS = "There are no Activity Assignment.",
  GRID_NO_CONTACT_NOTE_TYPE_CONFIG = "There are no Contact Note Type.",
  GRID_NO_TARGET_USERS = "There are no Target Users List.",
  GRID_NO_USER_GROUP = "There are no Users Group List.",
  GRID_NO_ALIGNEMENT_GROUP = "There are no Alignment List.",
  GRID_NO_ASSIGNER_ALIGNMENTS = "There are no Assigner Alignments List.",
  GRID_NO_POTENTIAL_DUPLICATES = "There are no Potential Duplicates",
  GRID_NO_TRAINING_REQUIREMENTS = "There are no Training requirements.",
  GRID_NO_FACULTY_SELECTIION_RULES = "There are no Faculty Selection Rules",
  GRID_NO_CREDENTIALS = "There are no Credentials and Specialties List.",
  GRID_NO_ALIGNMENT_LIMITS = "There are no Alignment Limits List.",
  GRID_NO_CONTACT_NOTES_MSG = "There are no Contact Notes.",
  GRID_NO_CONTRACT_MANAGEMENT_MSG = "There are no Contract Management List.",
  GRID_NO_CONTRACT_HISTORY_MSG = "There are no View Contract History List.",
  GRID_NO_GROUPING_CONFIGURATION_MSG = "There are no Grouping Configuration List.",
  GRID_NO_FACULTY_FOUND = "No Faculties were found.",
  GRID_NO_VIEW_HISTORY = "There are no View History List.",
  GRID_NO_COMMENTS_LIST = "There are no Comments List.",
  GRID_NO_CONTRACT_TEMPLATES = "There are no Contract Templates List.",
  GRID_NO_EXCLUDED_APPROVERS = "There are no Excluded Approvers List.",
  GRID_NO_USER_GROUP_MEMBERSHIP = "There are no User Group Membership List.",
  GRID_NO_STATE_GUIDELINES = "There are no State Guidelines List.",
  GRID_NO_INVITATION_TEMPLATES = "There are no Invitation Templates List.",
  GRID_NO_APPPROVAL_REQUIRED = "There are no Approval required List.",
  GRID_NO_REP_EVALUATION_CONFIG = "There are no Rep Evaluation Config List.",
  GRID_NO_EXPENSE_MANAGEMENT = "There are no Expense Management List.",
  GRID_NO_EXPENSE_APPROVAL_CONFIGURATION = "There are no Expense Approval Configuration List.",
  GRID_NO_EXPENSE_APPROVAL_EXCEPTION = "There are no Expense Approval Exception List.",
  GRID_NO_EXPENSE_CONTACT_NOTES_MSG = "There are no Expense Contact Notes.",
  GRID_NO_PROFILE_LIST = "There are no Profile List.",
  GRID_NO_RULE = "There are no Rule List.",
  GRID_NO_EMAIL_TEMPLATES = "There are no Email Templates List.",
  GRID_NO_BUDGET_EXEMPTION = "There are no Budget Exemption List.",
  GRID_NO_BUSINESS_JUSTIFICATION = "There are no Business Justification List.",
  GRID_NO_FACULTY_SELECTIION = "There are no Faculty Selection List.",
  GRID_NO_USER_GROUP_DIVISION_MAPPING = "There are no User Group & Division Mapping List.",
  GRID_NO_USER_MANAGEMENT = "There are no User Mangement Lists.",
  GRID_NO_TIER_BRAND_MAPPING = "There are no Tier Brand Mapping Lists.",
  GRID_NO_USER_MANAGEMENT_COMMENTS = "There are no Comment Lists.",
  GRID_NO_ACTIVITYCOMPLIANCE_EDITOR = "There are no Activity Compliance Lists.",
  GRID_NO_COMMENTHISTORY_EDITOR = "There are no Comment History.",
  GRID_NO_COMMENTS_EDITOR = "There are no Comments.",
  GRID_NO_USER_MANAGEMENT_FR_SEARCH = "There are no FR Lists.",
  GRID_NO_USER_MANAGEMENT_ALIGNMENT_SEARCH = "There are no Sales Force Lists.",
  GRID_NO_HONORARIUM_ADMIN = "There are no Honorarium Admin Lists.",
  GRID_NO_MERGE_FIELD_LIST = "There are no Merge Field Category List.",
  GRID_NO_SCREENING_ENTITY_LIST = "There are no Screening Entity List.",
  GRID_NO_ACTIVTY_RULE_LIST = "There are no Activity Rule List.",
  GRID_NO_FLAGLIST = "There are no Flag Lists.",
  GRID_NO_FINANCIAL_MAPPING_LIST = "There are no Financial Categories Mapping List.",
  GRID_NO_SALES_FORCE_ACCESS_LIST = "There are no Sales Force Access.",
  GRID_NO_SALES_ORG_RESTRICTIONS_LIST = "There are no Sales Org Restrictions.",
  GRID_NO_PARTICIPANTS_ADDED = "No participants added.",
  GRID_NO_PARTICIPANT_SEARCH_LIST = "No Records Found.",
  GRID_NO_INVOICE_FILES_LIST = "There are no Invoice File List.",
  GRID_NO_EXPENSE_DETAIL = "There are no Expense Detail List.",
  GRID_NO_MULTIPLE_ACTIVITIES = "There are no Multiple Activities List.",
  GRID_NO_REQUEST_FORM_INQUIRIES = "No request form inquiries have been sent in",
  GRID_NO_SIGNIN_SHEET_LIST = "There are no Sign-in Sheet List.",
  GRID_NO_UPLOAD_RECEIPT_LIST = "There are no Upload Receipt List.",
  GRID_NO_INVITEE_LIST = "There are no Invitee List.",
  GRID_NO_RSVP_INFOS_LIST = "There are no RSVP Info List.",
  GRID_NO_ATTENDEE_LIST = "There are no Attendee List.",
  GRID_NO_ACTIVITY_FINANCIALS_LIST = "There are no Activity Financials List.",
  GRID_NO_MEETING_MATERIALS_LIST = "There are no Meeting Materials List.",
  GRID_NO_BUDGET_APPROVAL_HISTORY_LIST = "There are no Budget Approval History Details List.",
  GRID_NO_COST_CENTERS_LIST = "There are no Cost Centers List.",
  GRID_NO_COST_CENTER_HISTORY_LIST = "There are no cost center history List.",
  GRID_NO_REPRESENTATIVE_LIST = "There are no Representative Lists.",
  GRID_NO_PIN_GENERATIONS_LIST = "There is no Pin Generation List.",
  GRID_NO_PID_DISTRIBUTION_LIST = "There are no PID Distribution Lists.",
  GRID_NO_MATERIAL_ORDER_DETAILS_LIST = "There are no Material Order Details Lists.",
  GRID_NO_ACTIVITY_COMMENTS_LIST = "There are no Activity Comments Lists.",
  GRID_NO_BUDGET_APPROVAL_LIST = "There are no Budget Approval Status Lists.",
}

export enum GenericProfileBreadCrumbs {
  PROFILE = 46,
  CONTACT_INFO = 47,
  TOPIC_INFO = 49,
  OPT_IN = 50,
  MISCELLANEOUS = 56,
  CV_BIO_PHOTO = 60,
  AFFILIATION_LICENSES = 87,
  TIERING = 91,
  TAX_FORMS = 104,
  SPEAKER_PROGRAM = 105,
  SUPPLIER_INFO = 106,
  USER_LIST = 107,
  COMMENTS = 108,
}

export enum OnOff {
  ON = "On",
  OFF = "Off",
}

export enum YesNo {
  YES = "Yes",
  NO = "No",
}

export enum ControlType {
  "textBox",
  "calendar",
  "dropDown",
  "multiSelect",
  "checkBox",
  "radioButton",
  "button",
  "label",
}

export enum FacultyAddressType {
  THIRD_PARTY_F = "3",
  ACADEMIC = "A",
  Clinical = "C",
  FINANCIAL = "F",
  HOME = "H",
  OFFICE = "O",
  PRACTICE = "P",
  UNSPECIFIED = "U",
}

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: CPSConstants.ITEM_HEIGHT * 4.5 + CPSConstants.ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export enum FacultyType {
  HCP = 1,
  PATIENT_CAREGIVER = 2,
  NON_HCP = 3,
}

export enum compTableColCells {
  "FDA Regulated",
  "Advising/Consulting",
  "Combined Funds(No Split)",
}
export enum RuleTypeId {
  COMBINED_RULE = 0,
  ADV = 1,
  FDA = 2,
}
export enum AllocationGrid {
  COMBINED = "COMBINED",
  ADV = "ADV",
  FDA = "FDA",
}
export enum RuleType {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export const SyncFusionToolbarSettings: object = {
  type: ToolbarType.MultiRow,
  enableFloating: false,
  items: [
    "Bold",
    "Italic",
    "Underline",
    "StrikeThrough",
    "FontName",
    "FontSize",
    "FontColor",
    "BackgroundColor",
    "LowerCase",
    "UpperCase",
    "Formats",
    "Alignments",
    "Blockquote",
    "OrderedList",
    "UnorderedList",
    "Outdent",
    "Indent",
    "CreateLink",
    "Image",
    "ClearFormat",
    "Print",
    "SourceCode",
    "FullScreen",
    "Undo",
    "Redo",
    "CreateTable",
  ],
};

export const SyncFusionToolbarSettingsForDropDown = {
  type: ToolbarType.MultiRow,
  enableFloating: false,
  items: [
    "Bold",
    "Italic",
    "Underline",
    "StrikeThrough",
    "FontName",
    "FontSize",
    "FontColor",
    "BackgroundColor",
    "LowerCase",
    "UpperCase",
    "Formats",
    "Alignments",
    "Blockquote",
    "OrderedList",
    "UnorderedList",
    "Outdent",
    "Indent",
    "CreateLink",
    "Image",
    "ClearFormat",
    "Print",
    "SourceCode",
    "FullScreen",
    "Undo",
    "Redo",
    "CreateTable",
  ],
};
export const SyncFusionQuickToolbarSettings: object = {
  image: [
    "Replace",
    "Align",
    "Caption",
    "Remove",
    "InsertLink",
    "OpenImageLink",
    "-",
    "EditImageLink",
    "RemoveImageLink",
    "Display",
    "AltText",
    "Dimension",
    "TableCell",
  ],
  link: ["Open", "Edit", "UnLink"],
  table: [
    "TableHeader",
    "TableRows",
    "TableColumns",
    "TableCell",
    "-",
    "BackgroundColor",
    "TableRemove",
    "TableCellVerticalAlign",
    "Styles",
  ],
};

export enum AlignmentRuleType {
  TERRITORY = "Territory",
  DISTRICT = "District",
  AREA = "Area",
  DIVISION = "Division",
}
export enum BrandRuleTypeId {
  RESERVE = "Reserve",
  LIMIT = "limit",
}
export enum breadCrumbIdsAddHCP {
  PROFILE = 29,
  CONTACTINFO = 30,
  SPONSORINFO = 31,
}
export enum subMenus {
  PROFILE = 29,
  CONTACTINFO = 30,
  SPONSORINFO = 31,
  SUPPLIER = 89,
}
export enum ActivitySubType {
  Unspecified = 0,

  Field = 1,

  Brand = 2,

  OUS = 3,

  Global = 4,

  Medical = 5,

  Future = 6,

  MarketingFDA = 7,

  MarketingAdvising = 8,

  Consulting = 9,
}
export enum DocumentTexts {
  UPDATEdOCUMENT = "Update Documents",
  UPLOADdOCUMENT = "Upload Documents",
  POPUPHEADERTEXT = "Document Type",
  POPUPHEADERDESC = "Browse and Upload Document",
  DOCUMENTNAME = "Document Name",
  UPDATETEXT = "Update",
  UPLOADTEXT = "Upload",
}

export enum AdminScreening {
  Entity = 2,
  HCP = 4,
}

export enum LoginType {
  Application = 1,
  LillyNetSSO = 2,
  OktaSSO = 3,
  MFA = 4,
}

export enum AlertTypeId {
  InvoiceApprovalAlert = 301,
  HonorariumAmountLoweredAlert = 10568,
  FADescriptionOfServiceApprovalAlert = 103,
  AdvActivityServiceApprovalAlertsPreviewOther = 108,
  AdvActivityServiceApprovalAlertsPreviewSingle = 183,
  AdvActivityServiceApprovalAlertsPreviewAdvBoard = 184,
  NonMedicalPersonnelApprovalAlertPreview = 98,
  EmailInvitationAlert = 10606,
}

export const API_RESPONSE_KEYS: string[] = [
  "messageCode",
  "message",
  "isSuccessMessage",
  "isErrorMessage",
  "isValidationMessage",
];

export enum ContractTypeKey {
  EContract = 1,
  Print = 2,
}

export enum ActivityType {
  Advising = 1,
  FDA = 2,
  Medical = 3,
}

export enum ContractStatus {
  NotYetSent = 1,
  Sent = 2,
  Received = 3,
  Declined = 4,
  InValidatedSent = 5,
  InValidatedReceived = 6,
  OnHold = 7,
  PendingNegotiation = 8,
  ApprovalRequired = 9,
}

export enum DocumentTypeKey {
  CV = 1,
  Bio = 2,
  Photo = 3,
  AnnualFacultyContract = 4,
  OfficeVisitAgreement = 5,
  MasterServiceAgreement = 6,
  RequestForService = 7,
  Addendum = 8,
  AdvisingDeviationForm = 9,
  ActivityContract = 10,
  SignInSheet = 11,
  W9 = 12,
  HardCopy = 13,
  Electronic = 14,
  USGeneralConsultingContract = 15,
  Amendment = 16,
  DMCContract = 17,
  Termination = 18,
  FDAVarianceForm = 19,
  Individual = 20,
  ThirdrdPartyPayee = 21,
  Exempt = 22,
  NonHCPContract = 23,
  PatientCaregiverContract = 24,
  DOLContract = 25,
}

export enum UserManagementUserType {
  FACULTY = 1,
  NON_FACULTY = 2,
  STANDARD = 3,
  ADVANCE = 5,
  CPP_ADMIN = 6,
  SALES_FORCE = 7,
  NON_SALES_FORCE = 8,
  FR_DELEGATE_STANDARD = 9,
}

export enum UserManagementMFAType {
  MOBILE = 2,
  EMAIL = 1,
}

export enum UserManagementSystemId {
  CPS = 1,
  CPP = 2,
  FR = 3,
}

export enum UserManagementUserStatusId {
  INACTIVE = 0,
  ACTIVE = 1,
  PENDING = 2,
  NOT_APPROVE = 4,
}

export enum UserManagementSalesForceInfoModule {
  AREA = "A",
  DISTRICT = "D",
  TERRITORY = "T",
}

export enum UserManagementSalesForceInfoLabel {
  AREA = "Area",
  DISTRICT = "District",
  TERRITORY = "Territory",
}

export enum ProgramTypes {
  FIELD_PROGRAM = 1,
  BRAND_FDA = 2,
}

export const AttachmentFileExtensionArray = [
  ".doc",
  ".docx",
  ".rtf",
  ".xls",
  ".xlsx",
  ".pdf",
  ".ppt",
  ".pptx",
  ".txt",
];
export const LogoFileExtensionArray = [".png", ".jpeg", ".jpg", ".gif", ".bmp"];

export const NOT_SUPPORTTED_FILE_EXTENSION = [
  "ASP",
  "PHP",
  "JSP",
  "EXE",
  "HTML",
  "PHP5",
  "PHT",
  "PHTML",
  "SHTML",
  "ASA",
  "CER",
  "ASAX",
  "SWF",
  "XAP",
];

export const BASE64EXTN = "data:application/octet-stream;base64,";

export enum RuleTypes {
  PLEASE_SELECT = -1,
  BLOCKING = 1,
  LIMITING = 2,
  SALESFORCE_TRAINING_AND_PERMISSIONING = 3,
  LICENSING = 4,
  CONTRACT_APPROVAL_REQUIRED = 5,
}

//To do reportscheduler
export enum ReportSchedulerBtn {
  Submit = "submit",
  Delete = "delete",
  Cancel = "Cancel",
}

export const ReportSchedulerConstants: {
  months: string[];
  workingDays: string[];
} = {
  months: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ],
  workingDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
};

export const DEFAULT_FA_TYPE_IDS = ["1", "2", "4"];
export const StateCodes = [
  {StateCode: "AK", Latitude: 61.385, Longitude: -152.2683},
  {StateCode: "AL", Latitude: 32.799, Longitude: -86.8073},
  {StateCode: "AR", Latitude: 34.9513, Longitude: -92.3809},
  {StateCode: "AS", Latitude: 14.2417, Longitude: -170.7197},
  {StateCode: "AZ", Latitude: 33.7712, Longitude: -111.3877},
  {StateCode: "CA", Latitude: 36.17, Longitude: -119.7462},
  {StateCode: "CO", Latitude: 39.0646, Longitude: -105.3272},
  {StateCode: "CT", Latitude: 41.5834, Longitude: -72.7622},
  {StateCode: "DC", Latitude: 38.8964, Longitude: -77.0262},
  {StateCode: "DE", Latitude: 39.3498, Longitude: -75.5148},
  {StateCode: "FL", Latitude: 27.8333, Longitude: -81.717},
  {StateCode: "GA", Latitude: 32.9866, Longitude: -83.6487},
  {StateCode: "HI", Latitude: 21.1098, Longitude: -157.5311},
  {StateCode: "IA", Latitude: 42.0046, Longitude: -93.214},
  {StateCode: "ID", Latitude: 44.2394, Longitude: -114.5103},
  {StateCode: "IL", Latitude: 40.3363, Longitude: -89.0022},
  {StateCode: "IN", Latitude: 39.8647, Longitude: -86.2604},
  {StateCode: "KS", Latitude: 38.5111, Longitude: -96.8005},
  {StateCode: "KY", Latitude: 37.669, Longitude: -84.6514},
  {StateCode: "LA", Latitude: 31.1801, Longitude: -91.8749},
  {StateCode: "MA", Latitude: 42.2373, Longitude: -71.5314},
  {StateCode: "MD", Latitude: 39.0724, Longitude: -76.7902},
  {StateCode: "ME", Latitude: 44.6074, Longitude: -69.3977},
  {StateCode: "MI", Latitude: 43.3504, Longitude: -84.5603},
  {StateCode: "MN", Latitude: 45.7326, Longitude: -93.9196},
  {StateCode: "MO", Latitude: 38.4623, Longitude: -92.302},
  {StateCode: "MP", Latitude: 14.8058, Longitude: 145.5505},
  {StateCode: "MS", Latitude: 32.7673, Longitude: -89.6812},
  {StateCode: "MT", Latitude: 46.9048, Longitude: -110.3261},
  {StateCode: "NC", Latitude: 35.6411, Longitude: -79.8431},
  {StateCode: "ND", Latitude: 47.5362, Longitude: -99.793},
  {StateCode: "NE", Latitude: 41.1289, Longitude: -98.2883},
  {StateCode: "NH", Latitude: 43.4108, Longitude: -71.5653},
  {StateCode: "NJ", Latitude: 40.314, Longitude: -74.5089},
  {StateCode: "NM", Latitude: 34.8375, Longitude: -106.2371},
  {StateCode: "NV", Latitude: 38.4199, Longitude: -117.1219},
  {StateCode: "NY", Latitude: 42.1497, Longitude: -74.9384},
  {StateCode: "OH", Latitude: 40.3736, Longitude: -82.7755},
  {StateCode: "OK", Latitude: 35.5376, Longitude: -96.9247},
  {StateCode: "OR", Latitude: 44.5672, Longitude: -122.1269},
  {StateCode: "PA", Latitude: 40.5773, Longitude: -77.264},
  {StateCode: "PR", Latitude: 18.2766, Longitude: -66.335},
  {StateCode: "RI", Latitude: 41.6772, Longitude: -71.5101},
  {StateCode: "SC", Latitude: 33.8191, Longitude: -80.9066},
  {StateCode: "SD", Latitude: 44.2853, Longitude: -99.4632},
  {StateCode: "TN", Latitude: 35.7449, Longitude: -86.7489},
  {StateCode: "TX", Latitude: 31.106, Longitude: -97.6475},
  {StateCode: "UT", Latitude: 40.1135, Longitude: -111.8535},
  {StateCode: "VA", Latitude: 37.768, Longitude: -78.2057},
  {StateCode: "VI", Latitude: 18.0001, Longitude: -64.8199},
  {StateCode: "VT", Latitude: 44.0407, Longitude: -72.7093},
  {StateCode: "WA", Latitude: 47.3917, Longitude: -121.5708},
  {StateCode: "WI", Latitude: 44.2563, Longitude: -89.6385},
  {StateCode: "WV", Latitude: 38.468, Longitude: -80.9696},
  {StateCode: "WY", Latitude: 43.076, Longitude: -107.2903},
];

export const InvoiceDetailFileExtensionArray = [
  ".png",
  ".jpeg",
  ".jpg",
  ".doc",
  ".docx",
  ".pdf",
];

export enum AD_DISPLAY_CLOSE_OUT_VALIDATION {
  CPP_Display_Receipts = 1,
  CPS_Display_Receipts = 2,
  CPP_Audience_Validation = 2,
  CPP_Financial_Validation = 3,
  CPS_Audience_Validation = 5,
  CPS_Financial_Validation = 6,
}

export const AD_DISPLAY_CLOSE_OUT_GROUPSTRUCTRUE = {1: [2, 3], 4: [5, 6]};

export const AD_CHECKIN_GROUPSTRUCTRUE = {1: [2], 3: [4], 5: [6]};

export enum SurveyQuestionTypes {
  Grid = "2",
  Numeric = "3",
  Radio = "4",
  RatingScale = "5",
  Text = "6",
  Consent = "33",
  SingleSelectMCQ = "65",
  MultiSelectMCQ = "64",
}
export enum SurveyStatusTypes {
  Draft = 40,
  Saved = 41,
  Published = 42,
  Closed = 43,
  ReOpened = 44,
}

export enum SurveyContactNoteTypes {
  Question = 30,
  Survey = 31,
  BusinessUnit = 32,
}
export enum FACULTIES_IN_ACTIVITIES_COLUMNS {
  Faculty_Type = "facultyType",
  Meeting_Date = "activityMeetingStartDate",
  Meeting_Time = "meetingTime",
  Meeting_Description = "meetingDescription",
  Location = "location",
  Travel_Type = "travelType",
  Action = "action",
  Accommodation = "accommodation",
}

export enum CancelledBy {
  LILLY_CORPORATE = 1,
  SPEAKER = 2,
  SALES_REP = 3,
}

export const timeZoneMap: Record<string, string> = {
  Eastern: "America/New_York",
  Central: "America/Chicago",
  Mountain: "America/Denver",
  Pacific: "America/Los_Angeles",
  Alaska: "America/Anchorage",
  Hawaii: "Pacific/Honolulu",
  Arizona: "America/Phoenix",
  Indiana: "America/Indiana/Indianapolis",
  Atlantic: "America/Halifax",
  CET: "Europe/Berlin",
  GST: "Asia/Dubai",
  HKT: "Asia/Hong_Kong",
  AEST: "Australia/Sydney",
  NZST: "Pacific/Auckland",
};

export enum FacultyActivityCalendar {
  FIELD_ACTIVITIES = "F",
  BRAND_ACTIVITIES = "B",
}

export const USACenterLocation = {lat: 39.8283, lng: -98.5795};

export enum DetailsTypes {
  FACULTY = "Faculty",
  ATTENDEE = "Attendee",
}

export enum API_TIMEOUTS_MILLISECONDS {
  LOGIN_CONTENT_ENDPOINT = 60000,
  LOGS_ENDPOINT = 60000,
  AUTHENTICATE_ENDPOINT = 60000,
  CHANGEPASSWORD_ENDPOINT = 60000,
  INDIVIDUALPAYMENTREPORT_ENDPOINT = 30000,
  ANNOUNCEMENT_VIEW_ALL_ENDPOINT = 30000,
  FIRSTTIMELOGIN_ENDPOINT = 60000,
  FETCHUSERSECURITYQUESTION_ENDPOINT = 60000,
  VERIFYCOSTCENTERNAME_ENDPOINT = 60000,
  USERTRAINING_ENDPOINT = 60000,
  FORGOTPASSOWRD_ENDPOINT = 30000,
  REQUESTACCOUNT_ENDPOINT = 60000,
  USERPROFILE_ENDPOINT = 120000,
  HEADER_INFORMATION_ENDPOINT = 30000,
  FETCH_DASHBOARD_DATA = 120000,
  LOGOUT_USER_ENDPOINT = 60000,
  FETCH_TOKEN = 60000,
  DASHBOARD_ANNOUNCEMENT_ENDPOINT = 60000,
  DASHBOARD_MESSAGE_ATTACH_ENDPOINT = 30000,
  CONTACT_US = 60000,
  // Alerts
  FRCOORDINATOR_FACULTY_REQUEST_ENDPOINT = 30000,
  FACULTY_POTENTIAL_DUPLICATES_ENDPOINT = 60000,
  NEW_FACULTY_ENDPOINT = 60000,
  MATCHED_FACULTY_ENDPONT = 60000,
  FACULTY_REQUEST_DETAIL_ALERT_ENDPOINT = 30000,
  FACULTY_APPROVAL_ALERT_ENDPOINT = 30000,
  FACULTY_APPROVAL_ALERTS_ENDPOINT = 30000,
  COST_CENTER_ALERT_ENDPOINT = 30000,
  COST_CENTER_ALERTS_ENDPOINT = 30000,
  ACTIVITY_OWNER_ALERTS_ENDPOINT = 30000,
  ACTIVITY_OWNER_ALERT_ENDPOINT = 30000,
  ACTIVITY_ALERT_ENDPOINT = 30000,
  ACTIVITY_HCP_REGISTRATION_ADMIN_ENDPOINT = 30000,
  ACTIVITY_HCP_REGISTRATION_ADMIN_PREVIEW_ENDPOINT = 30000,
  ACTIVITY_HCP_REGISTRATION_ADMIN_SAVE_ENDPOINT = 30000,
  FACULTY_MYLIST_ENDPOINT = 30000,
  FACULTY_MYLIST_DELETE_ENDPOINT = 30000,
  FACULTY_MYLIST_SAVE_ENDPOINT = 30000,
  FACULTY_MYLIST_GET_ENDPOINT = 300000,
  ARF_ASSIGNED_ENDPOINT = 30000,
  ARF_DISCONTINUED_ENDPONT = 30000,
  CMS_MANAGER_ALERT_ENDPOINT = 30000,
  ADVISING_REQUEST_FORM_ALERTS_ENDPOINT = 30000,
  ADVISING_REQUEST_FORM_ALERT_ENDPOINT = 30000,
  BUDGET_APPROVAL_ALERT_CONTROLS_ENDPOINT = 30000,
  BUDGET_APPROVAL_ALERT_ENDPOINT = 30000,
  BUDGET_APPROVAL_ALERTS_ENDPOINT = 30000,
  COORDINATOR_ALERT_CONTROLS_ENDPOINT = 30000,
  COORDINATOR_ALERT_ENDPOINT = 30000,
  COORDINATOR_ALERT_PRINT_ENDPOINT = 30000,
  HONORARIUM_EXCEPTION_ALERT_CONTROLS_ENDPOINT = 30000,
  HONORARIUM_EXCEPTION_ALERT_ENDPOINT = 30000,
  HONORARIUM_EXCEPTION_ALERTS_ENDPOINT = 30000,
  APPROVAL_FORM_UPLOAD_ENDPOINT = 30000,
  LILLY_USER_DETAIL_ENDPOINT = 30000,
  SERVER_MESSAGE_ENPOINT = 60000,
  SERVER_MESSAGES_ENPOINT = 60000,
  FACULTY_CV_ALERT_ENDPOINT = 30000,
  FACULTY_CV_ALERT_DOWNLOAD_ENDPOINT = 30000,
  FA_APPROVAL_ALERT_CONTROLS_ENDPOINT = 30000,
  FA_APPROVAL_ALERT_ENDPOINT = 30000,
  FA_APPROVAL_ALERTS_ENDPOINT = 30000,
  DMC_COMPLIANCE_ALERT_ENDPOINT = 30000,
  DMC_COMPLIANCE_ALERTS_ENDPOINT = 30000,
  NEW_ACCESS_ALERT_CONTROLS_ENDPOINT = 30000,
  FR_COORDINATOR_FACULTY_REQUEST_ALERT_ENDPOINT = 30000,
  VENUE_CATERER_APPROVAL_ALERTS_CONTROL_ENDPOINT = 30000,
  VENUE_CATERER_APPROVAL_ALERT_ENDPOINT = 30000,
  VENUE_CATERER_APPROVAL_ALERTS_ENDPOINT = 30000,
  MEDICAL_ALERT_CONTROL_ENDPOINT = 30000,
  MEDICAL_ALERT_ENDPOINT = 30000,
  MEDICAL_ALERTS_ENDPOINT = 30000,
  MEDICAL_INVOICE_ALERT_ENDPOINT = 30000,
  NEW_ACCESS_ALERT_ENDPOINT = 30000,
  PPQ_HOLDING_ALERT_ENDPOINT = 300000,
  PPQ_HOLDING_ALERT_CONTROLS_ENDPOINT = 30000,
  PPQ_FILE_ENDPOINT = 30000,
  PPQ_TIER_RATES_COMPARISON_ENDPOINT = 30000,
  SCREENING_ALERT_CONTROLS_ENDPOINT = 30000,
  SCREENING_ALERT_ENDPOINT = 60000,
  SCREENING_ALERTS_ENDPOINT = 60000,
  SCREENING_RESULTS_ENDPOINT = 60000,
  NEW_ACCESS_ALERTS_ENDPOINT = 30000,
  EXPANDED_SEARCH_ENDPOINT = 30000,
  INVITATION_TEMPLATE_APPROVAL_ALERT_ENDPOINT = 30000,
  INVITATION_TEMPLATE_APPROVAL_ALERTS_ENDPOINT = 30000,
  INVITATION_TEMPLATE_PRINT_ENDPOINT = 30000,
  OUS_APPROVAL_ALERT_ENDPOINT = 30000,
  OUS_APPROVAL_ALERTS_ENDPOINT = 30000,
  PPQ_APPROVAL_ALERT_ENDPOINT = 60000,
  PPQ_APPROVAL_ALERTS_ENDPOINT = 30000,
  PPQ_HOLDING_AREA_ALERT_ENDPOINT = 30000,
  REPORT_DETAILS_ENDPOINT = 30000,
  FACULTY_PROFILE_PHOTO = 30000,
  DOWNLOAD_REPORT_DETAILS_ENDPOINT = 600000,
  // Report
  REPORT_SCHEDULER_SCHEDULE_ENDPOINT = 30000,
  REPORT_SCHEDULER_SCHEDULES_ENDPOINT = 30000,
  REPORT_SCHEDULER_SCHEDULED_REPORT_ENDPOINT = 30000,
  REPORT_SCHEDULER_DOWNLOAD_REPORT_ENDPOINT = 600000,
  REPORT_SCHEDULER_DELETE_SCHEDULE_ENDPOINT = 30000,
  // Alert
  ORF_SUBMITTER_STATUS_ALERT_ENDPOINT = 120000,
  ORF_SUBMITTER_STATUS_ALERTS_ENDPOINT = 120000,
  ADDITIONAL_COMPENSATION_ALERT_CONTROLS_ENDPOINT = 30000,
  ADDITIONAL_COMPENSATION_ALERT_ENDPOINT = 30000,
  COMPENSATION_ALLOCATION_ENDPOINT = 30000,
  COMPENSATION_ALLOCATIONS_ENDPOINT = 30000,
  ORF_APPROVAL_STATUS_ALERT_ENDPOINT = 120000,
  ORF_APPROVAL_STATUS_ALERTS_ENDPOINT = 120000,
  FACULTY_VIDEO_ALERT_ENDPOINT = 30000,
  FACULTY_VIDEO_ALERTS_ENDPOINT = 30000,
  DMC_COMPLIANCE_ALERTPREVIEW_ENDPOINT = 30000,
  HONORARIUMLOWERED_ALERTPREVIEW_ENDPOINT = 30000,
  MILESTONE_PAYMENT_ALERTPREVIEW_ENDPOINT = 30000,
  DESC_OF_SERVICE_ALERTPREVIEW_ENDPOINT = 30000,
  HONORARIUM_EXCEPTION_ALERTPREVIEW_ENDPOINT = 30000,
  ADV_ACT_INVOICE_ALERTPREVIEW_ENDPOINT = 30000,
  ADV_ACTIVITY_SERVICE_APPROVAL_ALERTSPREVIEW = 30000,
  NONMEDICAL_PERSONNEL_APPROVAL_ALERTPREVIEW = 30000,
  BUDGETAPPROVAL_ALERT_FOR_MEDICALPREVIEW = 30000,
  BUDGETAPPROVAL_ALERT_FOR_NONMEDICALPREVIEW = 30000,
  // Faculty
  FACULTY_DETAIL_ENDPOINT = 30000,
  FACULTY_CONTROLS_ENDPOINT = 30000,
  FACULTY_BASIC_SEARCH_CONTROLS = 30000,
  FACULY_BASIC_SEARCH = 300000,
  FACULTY_ADVANCED_SEARCH_CONTROLS = 30000,
  FACULTY_ADVANCED_SEARCH = 300000,
  FACULTY_REQUEST_DETAILS_ENDPOINT = 30000,
  FACULTY_STATE_LEGISLATION = 30000,
  VENUE_CATERER_SEARCH_CONTROLS = 30000,
  SEARCH_VENUE_CATERER_CONTROLS = 30000,
  NOMINATE_VENUE_CATERER_CONTROLS = 30000,
  ADD_VENUE_CATERER_CONTROLS = 30000,
  FACULTY_PPQ_SEARCH = 120000,
  FACULTY_BULK_PPQ = 30000,
  FACULTY_PROFILE = 30000,
  FACULTY_PROFILE_DOCUMENT = 30000,
  FACULTY_PROFILE_SCREENING = 30000,
  FACULTY_PROFILE_SCREENING_OVERRIDE = 30000,
  FACULTY_CALENDAR_CONTROL = 30000,
  FACULTY_CALENDAR = 30000,
  FACULTY_CALENDAR_ACTIVITIES = 30000,
  FACULTY_COMMON_DEFAULTAPPROVER = 30000,
  FACULTY_COMMON_POTENTIALDUPLICATEFACULTIES = 30000,
  API_COMMON_ADDRESS = 30000,
  ADD_FACULTY_DETAILS = 30000,
  SAVE_MULTIPLE_FACULTY = 300000,
  MULTIPLE_FACULTY_CONTROLS = 30000,
  FACULTY_DETAILS = 30000,
  FACULTY_BRANDS_TOPICS = 30000,
  FACULTY_PROFILE_PPQ_DETAIL = 30000,
  FACULTY_PROFILE_DATA_VERIFICATION = 30000,
  ADD_EDIT_VENUE_CATERERS = 30000,
  ADD_EDIT_VENUE_CATERER = 30000,
  FACULTY_PROFILE_DOCUMENT_UPLOAD = 30000,
  FACULTY_PROFILE_DOCUMENT_CONTROLS = 30000,
  FACULTY_PROFILE_DOCUMENT_DETAILS = 30000,
  FACULTY_PROFILE_DOCUMENT_SEARCH = 30000,
  FACULTY_PROFILE_SEARCH_DEVIATION = 30000,
  FACULTY_PROFILE_DOCUMENT_DELETE = 30000,
  FACULTY_PROFILE_DATA_VERIFICATION_DETAILS = 30000,
  FACULTY_CONTRACT_CONTROL = 30000,
  FACULTY_CONTRACT = 30000,
  FACULTY_TRAINING = 30000,
  FACULTY_TRAINING_REQUIREMENTS = 30000,
  FACULTY_CONTRACT_FILE = 30000,
  FACULTY_INSTITUTION_DETAILS = 30000,
  SAVE_ACULTY_INSTITUTION_DETAILS = 30000,
  SPEAKER_PROGRAM_PREFRENCE_HISTORY = 30000,
  FACULTY_TIERING_CONTROLS = 30000,
  FACULTY_TIER = 30000,
  FACULTY_TIERS = 30000,
  FACUTLY_ZEROTIER = 30000,
  NOTE_TYPE_CONTROLS = 30000,
  FACULTY_CONTACT_NOTES = 300000,
  SAVE_DELETE_CONTACT_NOTES = 30000,
  FACULTY_CONTACT_NOTES_PRINT = 30000,
  FACULTY_ACTIVITY_STATS = 30000,
  FACULTY_ACTIVITY_STATS_DETAILS = 30000,
  FACULTY_ACTIVITY_MAP_CONTROLS = 30000,
  FACULTY_ACTIVITY_MAP_FILTER = 30000,
  FACULTY_ACTIVITY_MAP = 30000,
  FACULTY_TAX_FORM_UPLOAD_CONTROLS = 30000,
  FACULTY_TAX_FORM = 30000,
  FACULTY_TAX_FORM_UPLOAD = 50000,
  TAX_FILE_HISTORY = 30000,
  SAVE_TAX_FORMS = 30000,
  FACULTY_TOPIC_INFO = 30000,
  FACULTY_TOPIC_INFO_CONTROLS = 30000,
  FACULTY_SAVE_ADD_EDIT_TOPIC_INFO = 30000,
  FACULTY_TEXT_PROGRAM_ALERT = 30000,
  FACULTY_TRAVEL_PREFERENCE_CONTROL = 60000,
  FACULTY_TRAVEL_PREFERENCE = 30000,
  FACULTY_SAVE_TRAVEL_PREFERENCE = 30000,
  FACULTY_TRAVEL_PREFERENCE_DOCUMENT = 30000,
  FACULTY_TRAVEL_PREFERENCES_DOCUMENT_OPERATION = 30000,
  FACULTY_MISCELLANEOUSCONTROLS = 30000,
  FACULTY_MISCELLANEOUS = 30000,
  FACULTY_MISCELLANEOUSES = 30000,
  FACULTY_POTENTIAL_CONFLICTDATES = 30000,
  FACULTY_POTENTIAL_CONFLICTDATES_DELETE = 30000,
  FACULTY_DOCUMENT_INFORMATION_CONTROL = 60000,
  FACULTY_DOCUMENT_INFORMATION = 30000,
  FACULTY_SAVE_DOCUMENT_INFORMATION = 30000,
  FACULTY_SPP_CONTROLS = 30000,
  FACULTY_FETCH_SPP = 30000,
  FACULTY_SAVE_SPP = 30000,
  FACULTY_AFFILIATION_LICENSE = 30000,
  AFFILIATION_DETAILS = 30000,
  LICENSE_FILE = 120000,
  LICENSE_CONTROLS = 30000,
  FACULTY_SAVE_AFFILIATIONS = 30000,
  AFFILIATION_CONTROLS = 30000,
  AFFILIATION_RESULT = 30000,
  FACULTY_LICENSES = 60000,
  GET_LICENSE = 30000,
  FACULTY_CONTACT_INFO_ENDPOINT = 30000,
  FACULTY_EDIT_PROFILE_CONTROL = 30000,
  FACULTY_SCREENING_CONSENT = 30000,
  FACULTY_EXPENSE_EXCEPTION_CONTROLS = 30000,
  FACULTY_SBINDICATOR_CONTROLS = 30000,
  FACULTY_EDIT_PROFILE = 30000,
  FACULTY_EDIT_PROFILES = 30000,
  FACULTY_EDIT_PPQ_CONTROLS = 30000,
  FACULTY_EDIT_PPQ_DETAIL = 30000,
  FACULTY_EDIT_PPQ_DETAILS = 30000,
  FACULTY_DATA_VERFICATIONS = 30000,
  FACULTY_ORGANIZATION_CONTACT = 30000,
  FACULTY_DATA_VERIFICATION = 30000,
  FACULTY_RULE = 30000,
  FACULTY_ADDRESS = 30000,
  FACULTY_ALLOCATION_CONTROLS = 30000,
  FACULTY_ALLOCATION_DATA = 30000,
  FACULTY_ALLOCATIONS = 30000,
  FACULTY_ALLOCATE_FUND_CONTROLS = 30000,
  FACULTY_ALLOCATE_FUND = 30000,
  FACULTY_BRAND_RULES = 30000,
  FACULTY_ALLOCATION_BREAKDOWN = 30000,
  FACULTY_ALIGNMENT_RULE = 30000,
  FACULTY_ALIGNMENT_RULES = 30000,
  FACULTY_COMPENSATION_UTILIZATION = 30000,
  FACULTY_COMPENSATION_CONTACT_NOTE = 30000,
  FACULTY_SAVE_COMPENSATION_CONTACT_NOTE = 30000,
  FACULTY_SEARCH_REPRESENTATIVE = 30000,
  FACULTY_ALLOCATE_FUNDS = 30000,
  FACULTY_OPTOUT_RESEND = 30000,
  FACULTY_COMPENSATION_DOWNLOAD_TO_EXCEL = 300000,
  FACULTY_REQUEST_FOR_FUND = 30000,
  FACULTY_BRAND_COMPENSATION_APPROVER = 30000,
  FACULTY_REQUEST_FOR_FUNDS = 30000,
  FACULTY_ALLOCATION_BRAND_NOTES_CONTROLS = 30000,
  FACULTY_ALLOCATION_BRAND_NOTES = 30000,
  FACULTY_ALLOCATION_DOWNLOAD_NOTES = 300000,
  FACULTY_ALLOCATION_VIEW_NOTES = 30000,
  FACULTY_VERIFY_ACTIVITY = 30000,
  LOGIN_VERIFY_MFA_OTP = 60000,
  LOGIN_RESEND_OTP = 60000,
  COMMON_MFA_PREFERRED = 30000,
  COMMON_MFA_PREFERREDS = 60000,
  COMMON_SEND_MFA_PHONE_OTP = 60000,
  COMMON_VERIFY_MFA_PHONE_OTP = 60000,
  ADMIN_METADATA_CONTROL = 30000,
  ADMIN_METADATA_LIST = 30000,
  ADMIN_METADATA_SAVE = 30000,
  ADMIN_METADATA_COMPENSATION_CONTROL = 30000,
  ADMIN_ACTIVITY_SERIES = 30000,
  ADMIN_FACULTY_ID_CHANGE = 30000,
  ADMIN_METADATA_COMPENSATION_LIMIT = 30000,
  ADMIN_METADATA_COMPENSATION_LIMIT_SAVE = 30000,
  ADMIN_DOC_ON_FILE = 30000,
  ADMIN_COST_CENTER_EXCEL = 50000,
  ADMIN_SAVE_COST_CENTER = 60000,
  ADMIN_SAVE_COST_CENTER_IMPORT = 30000,
  ADMIN_SAMPLE_IO = 30000,
  ADMIN_SAVE_IO = 30000,
  ADMIN_TAX_TEXT_CONFIGURATION_LIST = 30000,
  ADMIN_EDIT_TAX_TEXT_CONFIGURATION_LIST = 30000,
  ADMIN_SAVE_TAX_TEXT_CONFIGURATION_LIST = 30000,
  ADMIN_TAX_AUTHORITY_CONTROL = 30000,
  ADMIN_TAX_AUTHORITY = 30000,
  ADMIN_SAVE_TAX_AUTHORITY = 30000,
  ADMIN_CLONE_TAX_AUTHORITY = 30000,
  ADMIN_MEDICALDD_FIELDS_LIST_CONTROL = 30000,
  ADMIN_MEDICALDD_FIELDS_LIST = 30000,
  ADMIN_MEDICALDD_FIELD_CONTROL = 30000,
  ADMIN_MEDICALDD_FIELD_VALUE_SAVE = 30000,
  ADMIN_MEDICALDD_FIELD_VALUE = 30000,
  ADMIN_1099_REPORTING_APPROVAL = 300000,
  ADMIN_1099_REPORT_FILE = 300000,
  ADMIN_1099_REPORTING_APPROVAL_UPLOAD = 300000,
  ADMIN_DOWNLOAD_1099_FILE = 300000,
  ADMIN_DOWNLOAD_1099_IRS_FILE = 300000,
  ADMIN_PREVIEW_EXPORT_CONTROL = 300000,
  ADMIN_1099_GENERATE_DETAIL_REPORT = 300000,
  ADMIN_1099_PREVIEW_EXPORT_SEARCH = 300000,
  ADMIN_1099_REPORTING_APPROVALS = 300000,
  ADMIN_AFFILIATION_CONTROL = 30000,
  ADMIN_SEARCH_AFFILIATION = 30000,
  ADMIN_FETCH_AFFILIATION = 30000,
  ADMIN_SAVE_AFFILIATION = 30000,
  ADMIN_SCREENING_CONTROL = 30000,
  ADMIN_SEARCH_SCREENING = 30000,
  ADMIN_SCREENING_RESULTS = 30000,
  ADMIN_SUPPLIER_BRAND_RULE_SEARCH_CONTROL = 30000,
  ADMIN_SUPPLIER_BRAND_RULE_SEARCH = 300000,
  ADMIN_SCREENING_ENTITY_SEARCH = 30000,
  ADMIN_SAVE_SCREENING_ENTITY = 30000,
  ADMIN_GET_AFR_CONFIG = 30000,
  ADMIN_SAVE_AFR_CONFIG = 30000,
  ADMIN_GET_ORF_CONFIG_COMMENT = 30000,
  ADMIN_SAVE_ORF_CONFIG_COMMENT = 30000,
  ADMIN_SUPPLIER_BRAND_RULE = 30000,
  ADMIN_SUPPLIER_BRAND_RULE_SAVE = 30000,
  ADMIN_SUPPLIER_BRAND_RULE_FETCH = 30000,
  ADMIN_SUPPLIER_MAPPING_LIST = 30000,
  ADMIN_SUPPLIER_MAPPING_CONTROLS = 30000,
  ADMIN_SUPPLIER_MAPPING_FETCH = 30000,
  ADMIN_SUPPLIER_MAPPING_SAVE = 30000,
  ADMIN_VMS_FACULTY_CONTROL = 30000,
  ADMIN_VMS_FACULTY_LIST = 30000,
  ADMIN_VMS_FACULTY_DETAILS_FETCH = 30000,
  ADMIN_VMS_FACULTY_SEARCH_CONTOL = 30000,
  ADMIN_VMS_FACULTY_SEARCH_FACULTY = 30000,
  ADMIN_VMS_FACULTY_DETAILS_SAVE = 30000,
  ADMIN_FIELD_ALIGNMENT_MAPPING_CONTROL = 30000,
  ADMIN_SAVE_FIELD_ALIGNMENT_MAPPING = 300000,
  ADMIN_GET_REQUEST_FORM_CONFIGURATION_CONTROL = 30000,
  ADMIN_SAVE_REQUEST_FORM_CONFIGURATION = 30000,
  ADMIN_GET_REQUEST_FORM_CONFIGURATION_COMMENT = 30000,
  ADMIN_SAVE_REQUEST_FORM_CONFIGURATION_COMMENT = 30000,
  ADMIN_GET_REQUEST_FORM = 30000,
  ADMIN_SAVE_REQUEST_FORM = 30000,
  ADMIN_UPDATE_CONTRACT_MANAGEMENT_COPY_ENDPOINT = 300000,
  END_DATE_BULK_UPLOAD_ENDPOINT = 300000,

  RESOURCE_POST_LIST = 30000,
  RESOURCE_POST_CONTENT = 30000,
  RESOURCE_POST_FILE = 30000,
  // start admin -> Ad Board/SAA -> Advising Central Member
  ADVISING_CENTRAL_MEMBER_CONTROL = 30000,
  ADVISING_CENTRAL_MEMBERS = 30000,
  // end

  // start admin -> Ad Board/SAA -> Affiliates
  AFFILIATE_LIST = 30000,
  SAVE_AFFILIATE_DETAILS = 30000,
  FETCH_AFFILIATE_DETAILS = 30000,
  // end

  // start admin -> Ad Board/SAA -> Credentials for Payment Limits
  FETCH_PAYMENT_LIMIT_CREDENTIAL = 30000,
  SAVE_PAYMENT_LIMIT_CREDENTIAL = 30000,
  // end

  // start admin -> Ad Board/SAA -> Anticipated Work Products
  FETCH_ANTICIPATED_WORK_PRODUCT_LIST = 30000,
  FETCH_ANTICIPATED_WORK_PRODUCT_DETAILS = 30000,
  SAVE_ANTICIPATED_WORK_PRODUCT_DETAILS = 30000,
  // end

  // start admin -> Ad Board/SAA -> Commercial Decision Status
  FETCH_COMMERCIAL_DECISION_STATUS_LIST = 30000,
  FETCH_COMMERCIAL_DECISION_STATUS_DETAILS = 30000,
  SAVE_COMMERCIAL_DECISION_STATUS_DETAILS = 30000,
  // end

  // start admin -> Ad Board/SAA -> Communication Type
  FETCH_COMMUNICATION_TYPE_LIST = 30000,
  FETCH_COMMUNICATION_TYPE_DETAILS = 30000,
  SAVE_COMMUNICATION_TYPE_DETAILS = 30000,
  // end

  // start admin -> Ad Board/SAA -> Non-Medical Personnel Areas
  FETCH_NON_MEDICAL_PERSONNEL_AREA_LIST = 30000,
  FETCH_NON_MEDICAL_PERSONNEL_AREA_DETAILS = 30000,
  SAVE_NON_MEDICAL_PERSONNEL_AREA_DETAILS = 30000,
  // end

  // start admin -> Ad Board/SAA -> Business Areas
  FETCH_BUSINESS_UNITS_LIST = 30000,
  FETCH_BUSINESS_UNITS_DETAILS = 30000,
  SAVE_BUSINESS_UNITS_DETAILS = 30000,
  BUSINESS_UNITS_CONTROL = 30000,
  // end

  // start admin -> Ad Board/SAA -> Therapeutic Areas
  FETCH_THERAPEUTIC_AREA_LIST = 300000,
  THERAPEUTIC_AREA_CONTROL = 30000,
  FETCH_THERAPEUTIC_AREA_DETAILS = 30000,
  SAVE_THERAPEUTIC_AREA_DETAILS = 30000,
  // end

  // start admin -> Ad Board/SAA -> Individual Payment Limits
  INDIVIDUAL_PAYMENT_LIMIT_SEARCH_CONTROL = 30000,
  INDIVIDUAL_PAYMENT_LIMIT_SEARCH = 300000,
  INDIVIDUAL_PAYMENT_LIMIT_CONTROL = 30000,
  FETCH_INDIVIDUAL_PAYMENT_LIMIT_DETAILS = 30000,
  SAVE_INDIVIDUAL_PAYMENT_LIMIT_DETAILS = 30000,
  // end

  // start admin -> utilities -> District Territory Manager
  DISTRICT_TERRITORY_MANAGER_CONTROL = 30000,
  DISTRICT_TERRITORY_MANAGER_FACULTY_SEARCH = 30000,
  DISTRICT_TERRITORY_MANAGER_DOWNLOAD = 300000,
  DISTRICT_TERRITORY_MANAGER_UPLOAD = 30000,
  // end

  //Admin - utilities - AI
  ADMIN_AICOMPLIANCEQUEUE_CONTROL = 30000,
  ADMIN_SEARCH_AICOMPLIANEQUEUE = 180000,
  AI_QUEUE_SUBMITTER_ENDPOINT = 60000,
  ADMIN_QUEUE_HISTORY = 30000,

  ADMIN_AICOMPLIANCE_RULE_CONFIGURATION_CONTROL = 30000,
  ADMIN_SEARCH_AICOMPLIANCE_RULE = 30000,
  // start admin -> utilities -> Update sApprover
  UPDATE_APPROVERS_CONTROL = 30000,
  APPROVER_CONFIGURATIONS_SEARCH = 30000,
  SAVE_APPROVER_CONFIGURATIONS = 30000,
  ADMIN_SUPPLIER_LIST = 30000,
  ADMIN_SUPPLIER_CONTROL = 30000,
  ADMIN_SUPPLIER_DETAILS = 30000,
  ADMIN_SUPPLIER_DETAILS_SAVE = 120000,
  ADMIN_SUPPLIER_USER_LIST = 30000,
  ADMIN_SUPPLIER_COMMENTS = 30000,
  ADMIN_SUPPLIER_COMMENTS_SAVE = 30000,

  // start admin -> Activity Configuration ->
  ADMIN_PAYMENT_CONFIGURATION_SEARCH_CONTROL = 30000,
  ADMIN_PAYMENT_CONFIGURATION_SEARCH = 30000,
  ADMIN_PAYMENT_CONFIGURATION_CONTROL = 30000,
  ADMIN_PAYMENT_CONFIGURATION_BATCH = 30000,
  SAVE_ADMIN_PAYMENT_CONFIGURATIONS = 120000,
  ADMIN_PAYMENT_CONFIG_MONITOR_CONFIGURATION = 30000,
  SAVE_ADMIN_PAYMENT_CONFIG_MONITOR_CONFIGURATION = 120000,
  // Start admin -> Brands -> Brand Aprrovers
  ADMIN_BRAND_APPROVER_CONTROL = 30000,
  ADMIN_BRAND_APPROVERS = 30000,
  ADMIN_DOWNLOAD_BRAND_APPROVERS = 300000,
  ADMIN_BRAND_APPROVER_DELETE = 30000,
  ADMIN_BRAND_ASSIGN_APPROVER = 30000,
  ADMIN_BRAND_ASSIGN_APPROVER_SAVE = 30000,
  ADMIN_BRAND_COMPENSATION_CONTROL = 30000,
  ADMIN_BRAND_COMPENSATION_APPROVERS = 30000,
  ADMIN_BRAND_COMPENSATION_DELETE = 30000,
  //End

  // Start admin -> Brands -> Aprrovers
  ADMIN_APPROVER_ASSIGNMENT_LIST = 30000,
  ADMIN_APPROVER_ASSIGNMENT_CONTROL = 30000,
  ADMIN_APPROVER_ASSIGNMENT_SPONSOR = 30000,
  ADMIN_APPROVER_ASSIGNMENT = 30000,
  ADMIN_APPROVER_ASSIGNMENTS_SAVE = 30000,
  //End

  //Start -> Brands -> OUS Approvers
  ADMIN_OUS_APPROVER_CONTROL = 30000,
  ADMIN_OUS_APPROVERS = 30000,
  ADMIN_DOWNLOAD_OUS_APPROVERS = 300000,
  ADMIN_OUS_APPROVERS_DELETE = 30000,
  //end

  ADMIN_GET_SPP_BRAND_CONFIG = 30000,
  ADMIN_SAVE_SPP_BRAND_CONFIG = 30000,
  ADMIN_SEARCH_SPP_NOTIFICATION = 30000,
  ADMIN_SAVE_SPP_NOTIFICATION = 30000,
  ADMIN_SEARCH_SPP_ANNUAL_NOTIFICATION = 30000,
  ADMIN_SAVE_SPP_ANNUAL_NOTIFICATION = 30000,
  ADMIN_GET_SPP_BRAND_CONFIGURATION_COMMENT = 30000,
  ADMIN_ADDEDIT_SPP_BRAND_CONFIGURATION_COMMENT = 30000,
  // Brands and Sub brands
  ADMIN_GET_BRAND_CONFIGURATION_LIST = 300000,
  ADMIN_GET_COST_CENTER_RULE_LIST = 30000,
  ADMIN_GET_BRAND_CONFIGURATION_CONTROL = 30000,
  ADMIN_GET_BRAND_CONFIGURATION = 30000,
  ADMIN_GET_BRAND_HISTORY = 30000,
  ADMIN_GET_BRAND_HELP_CONTENT = 30000,
  ADMIN_SAVE_BRAND_LOGO = 30000,
  ADMIN_SAVE_BRAND_CONFIGURATION = 120000,

  //start -> Admin -> Contract -> AssignerAlignment
  ADMIN_ASSIGNER_ALIGNMENTS = 30000,
  ADMIN_SEARCH_ASSIGNER_ALIGNMENTS = 30000,
  ADMIN_DOWNLOAD_ASSIGNER_ALIGNMENTS = 300000,
  ADMIN_ASSIGNER_ALIGNMENTS_DIVISION_CONTROL = 30000,
  ADMIN_ASSIGNER_ALIGNMENT_DIVISIONS_SAVE = 30000,
  ADMIN_ASSIGNER_ALIGNMENT_DIVISION_FETCH = 30000,
  ADMIN_ASSIGNER_ALIGNMENT_DELETE = 30000,
  ADMIN_ASSIGNER_ALIGNMENT_ADD = 30000,

  ADMIN_ALERT_PREFERENCE_SCREEN_CONTROL_GET = 30000,
  ADMIN_ALERT_PREFERENCE_SCREEN_POST = 30000,
  ADMIN_ALERT_PREFERENCES_SCREENS_POST = 30000,
  ADMIN_CONTACT_NOTE_CONFIG_LIST_POST = 30000,
  ADMIN_CONTACT_NOTE_CONFIG_CONTROL_GET = 30000,
  ADMIN_CONTACT_NOTE_CONFIG_POST = 30000,
  ADMIN_CONTACT_NOTE_CONFIGS_POST = 30000,

  ADMIN_CONTENT_MANAGEMENT_LIST_POST = 90000,
  ADMIN_CONTENT_LIST_POST = 3000000,
  ADMIN_CONTENT_MANAGEMENT_FOLDER_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_FILE_DELETE_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_RANK_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_FILE_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_FILES_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_FILE_VERSION_DOWNLOAD_POST = 3000000,
  ADMIN_CONTENT_MANAGEMENT_FILE_CONTROL_GET = 30000,
  ADMIN_CONTENT_MANAGEMENT_FILE_DOWNLOAD_POST = 3000000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSION_CPP_ACCESSIBLE_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSION_CONTROL_POST = 60000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSION_USERS_POST = 60000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSION_FR_USERS_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSION_FR_USER_DELETE_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSION_POST = 60000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSIONS_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSIONS_SEARCH_POST = 30000,
  ADMIN_CONTENT_MANAGEMENT_PERMISSIONS_USER_GROUP_POST = 30000,
  ADMIN_USER_GROUP_SEARCH_CONTROL_GET = 30000,
  ADMIN_USER_GROUP_POST = 30000,
  ADMIN_USER_GROUPS_POST = 30000,
  ADMIN_USER_GROUP_CONTROL_GET = 30000,
  ADMIN_USER_GROUP_SEARCH_POST = 30000,
  // Admin: Business Justification
  ADMIN_BUSINESS_JUSTIFICATION_SEARCH_CONTROL = 300000,
  ADMIN_BUSINESS_JUSTIFICATION_SUGGEST = 30000,
  ADMIN_BUSINESS_JUSTIFICATION_SEARCH = 300000,
  ADMIN_BUSINESS_JUSTIFICATION_CONTROL = 300000,
  ADMIN_BUSINESS_JUSTIFICATION = 300000,
  ADMIN_BUSINESS_JUSTIFICATIONS = 30000,
  //end

  // Start admin -> Contracts -> Finalize Strategic Funds
  FINALIZE_STRATEGIC_FUND_CONTROL = 30000,
  FINALIZE_STRATEGIC_FUNDS = 300000,
  FINALIZE_STRATEGIC_FUNDS_DOWNLOAD = 300000,
  //end

  // Faculty Selection Rules
  ADMIN_GET_FACULTY_SELECTION_RULE_LIST = 30000,
  ADMIN_FACULTY_SELECTION_RULE_CONTROL = 30000,
  ADMIN_EDIT_FACULTY_SELECTION_RULE = 30000,
  ADMIN_SAVE_FACULTY_SELECTION_RULE = 30000,

  //start Admin-> Contracts -> Alignment Limits
  ADMIN_ALIGNMENT_LIMIT_LIST = 30000,
  ADMIN_ALIGNMENT_LIMIT_CONTROL = 30000,
  ADMIN_ALIGNMENT_LIMITS_SAVE = 30000,
  ADMIN_ALIGNMENT_LIMIT = 30000,
  //end

  //start Admin-> Contracts -> Contract Templates
  CONTRACT_TEMPLATE_CONTROL = 300000,
  CONTRACT_TEMPLATE_REFRESH_OWNERSHIP = 300000,
  CONTRACT_TEMPLATE_SEARCH = 300000,
  CONTRACT_TEMPLATE_FILE = 120000,
  CONTRACT_TEMPLATE_INFORMATION_CONTROL = 120000,
  CONTRACT_TEMPLATE_INFORMATION = 300000,
  SAVE_CONTRACT_TEMPLATE_INFORMATIONS = 300000,
  CONTRACT_TEMPLATE_MERGE_FIELD = 120000,
  SAVE_CONTRACT_TEMPLATE_MERGE_FIELD = 120000,
  //end

  //Admin -> Brands -> Topics Training Requirements
  ADMIN_TOPIC_REQ_CONTROL = 30000,
  ADMIN_TOPIC_REQ_LIST = 300000,
  ADMIN_TOPIC_REQ_FETCH = 30000,
  ADMIN_TOPIC_REQ_SAVE = 30000,
  ADMIN_TOPIC_REQ_History = 30000,

  //Admin -> Contracts -> Contract Management
  ADMIN_CONTRACT_MANAGEMENT_CONTROL = 30000,
  ADMIN_SEARCH_CONTRACT_MANAGEMENT_CONTROL = 180000,
  ADMIN_FETCH_CONTRACT_HISTORY_CONTROL = 30000,
  ADMIN_SEARCH_CONTRACT_HISTORY = 30000,
  ADMIN_SAVE_CONTRACT_HISTORY = 30000,
  ADMIN_GET_CONTRACT_FILE = 20000,
  ADMIN_GET_CONTRACT_EMAIL = 30000,
  ADMIN_SEND_CONTRACT_EMAIL = 30000,
  ADMIN_SAVE_CONTRACT_MANAGEMENT = 30000,

  //Admin -> Brands -> Topics Training Requirements Administration
  ADMIN_TOPIC_TRAINING_ADMIN_CONTROL = 30000,
  ADMIN_TOPIC_TRAINING_ADMIN_FACULTY_CONTROL = 30000,
  ADMIN_TOPIC_TRAINING_ADMIN_FACULTY_SEARCH = 60000,
  ADMIN_TOPIC_TRAINING_ADMIN_FACULTY_SAVE = 30000,
  ADMIN_TOPIC_TRAINING_ADMIN_ACTIVITY_CONTROL = 30000,
  ADMIN_TOPIC_TRAINING_ADMIN_ACTIVITY_SEARCH = 60000,
  ADMIN_TOPIC_TRAINING_ADMIN_ACTIVITY_SAVE = 30000,
  ADMIN_TOPIC_TRAINING_FIELD_ACTIVITY_CONTROL = 30000,
  ADMIN_TOPIC_TRAINING_FIELD_ACTIVITY_SEARCH = 30000,
  ADMIN_TOPIC_TRAINING_FIELD_ACTIVITY_SAVE = 30000,
  ADMIN_COMPLIANCE_ACKNOWLEDGE_FORM = 30000,
  //End Admin -> Brands -> Topics Training Requirements Administration

  //Admin -> Admin Tools -> Credentials and Specialties
  ADMIN_CREDENTIAL_CONTROL = 30000,
  ADMIN_CREDENTIAL_LIST = 300000,
  ADMIN_CREDENTIAL_SAVE = 30000,
  ADMIN_CREDENTIAL_FETCH = 30000,
  ADMIN_SPECIALTY_SAVE = 30000,
  ADMIN_SPECIALTY_FETCH = 30000,
  //End Admin -> Admin Tools -> Credentials and Specialties

  ADMIN_AICOMPLIANCEMONITORINGQUEUE_CONTROL = 30000,
  ADMIN_GET_AICOMPLIANCEREVIEW_CONTROL = 30000,
  ADMIN_SEARCH_AICOMPLIANCEREVIEW = 30000,
  ADMIN_GET_AICOMPLIANCE_ActivityIdentityDetails = 80000,
  ADMIN_SEARCH_AICOMPLIANCEGetFlagDetails = 60000,
  ADMIN_GET_AICOMPLIANCEACTIVITYCOMMENTHISTORY = 30000,
  ADMIN_SAVE_AIComplianceQueueActivitySync = 180000,
  ADMIN_UPDATE_AIComplianceActivityFlagComment = 80000,
  ADMIN_Save_AICOMPLIANCEFlagDetails = 80000,
  ADMIN_GET_AICOMPLIANCERULECONFIGURATION_CONTROL = 60000,
  ADMIN_GET_AICOMPLIANCERULEIDDETAILS = 30000,
  ADMIN_SAVE_AICOMPLIANCERULECONFIGURATION = 180000,

  //Admin -> Admin Tools -> Excluded Approvers
  ADMIN_EXCLUDED_APPROVER_SEARCH = 300000,
  ADMIN_EXCLUDED_APPROVER_FETCH = 30000,
  ADMIN_EXCLUDED_APPROVER_SAVE = 30000,
  //End Admin -> Admin Tools -> Excluded Approvers

  //Admin -> Admin Tools -> FR Content Associations
  ADMIN_FR_CONTENT_ASSO_CONTROL = 30000,
  ADMIN_FR_CONTENT_ASSO_SEARCH = 30000,
  ADMIN_FR_CONTENT_ASSO_DETAILS = 30000,
  ADMIN_FR_CONTENT_ASSO_USERGROUP_CONTROL = 30000,
  ADMIN_FR_CONTENT_ASSO_USERGROUP_SEARCH = 30000,
  ADMIN_FR_CONTENT_ASSO_DETAILS_SAVE = 30000,
  //End Admin -> Admin Tools -> FR Content Associations

  //Admin -> Admin Tools -> Announcement Editor
  ADMIN_ANNOUNCEMENT_EDITOR_CONTROL = 30000,
  ADMIN_SEARCH_ANNOUNCEMENT_EDITOR = 30000,
  ADMIN_ANNOUNCEMENT_EDITOR_CONTROLS = 30000,
  ADMIN_FETCH_ANNOUNCEMENT_EDITOR = 30000,
  ADMIN_SAVE_ANNOUNCEMENT_EDITOR = 30000,
  ADMIN_FETCH_ANNOUNCEMENT_TARGET_USER_CONTROL = 30000,
  ADMIN_SEARCH_ANNOUNCEMENT_TARGET_USER = 30000,
  ADMIN_FETCH_ANNOUNCEMENT_ADD_ALIGNMENT_CONTROL = 30000,
  ADMIN_FETCH_ANNOUNCEMENT_ADD_FR_USERGROUP_CONTROL = 30000,

  //Admin -> Admin Tools -> State Guidelines
  ADMIN_STATE_GUIDELINES_LIST_FETCH = 300000,
  ADMIN_STATE_GUIDELINES_CONTROL_FETCH = 30000,
  ADMIN_STATE_GUIDELINES_SAVE = 120000,
  ADMIN_STATE_GUIDELINE_DETAILS_FETCH = 120000,
  //

  //Admin -> Admin Tools -> FR Content Config
  ADMIN_FR_CONTENT_CONFIG_SEARCH_CONTROL = 120000,
  ADMIN_FR_CONTENT_CONFIG_SEARCH = 120000,
  ADMIN_FR_CONTENT_CONFIG_CONTROL = 120000,
  ADMIN_FR_CONTENT_CONFIG_RULE_CONTROL = 120000,
  ADMIN_FR_CONTENT_CONFIG_USER_CONTROL = 120000,
  ADMIN_FR_CONTENT_CONFIG_USER_SEARCH = 120000,
  ADMIN_FR_CONTENT_CONFIG_SAVE = 120000,
  ADMIN_FR_CONTENT_CONFIG_FETCH = 120000,
  //

  //Admin -> Admin Tools -> Invitation Template
  ADMIN_INVITATION_TEMPLATE_SEARCH_CONTROL = 120000,
  ADMIN_INVITATION_TEMPLATE_SEARCH = 300000,
  ADMIN_INVITATION_TEMPLATE_FILE = 120000,
  ADMIN_INVITATION_TEMPLATE_CONTROL = 120000,
  ADMIN_INVITATION_TEMPLATE_SAVE = 120000,
  ADMIN_INVITATION_TEMPLATE_FETCH = 120000,
  //

  //Admin -> Admin Tools -> Grouping Configuration
  ADMIN_GROUP_CONFIG_SEARCH_CONTROL = 120000,
  ADMIN_GROUP_CONFIG_SEARCH = 300000,
  ADMIN_GROUP_CONFIG_CONTROL = 120000,
  ADMIN_GROUP_CONFIG_SAVE = 120000,
  ADMIN_GROUP_CONFIG_FETCH = 120000,
  //

  //start Admin-> Admin tools -> AutomatedBusinessTask
  AUTOMATED_BUSINESS_TASK_CONTROL = 30000,
  AUTOMATED_BUSINESS_TASK = 30000,
  AUTOMATED_BUSINESS_TASK_DOWNLOAD = 300000,
  AUTOMATED_BUSINESS_TASK_MAPPING = 30000,
  SAVE_AUTOMATED_BUSINESS_TASKS = 300000,
  //End Admin -> Admin tools -> AutomatedBusinessTask

  //start Admin-> Admin tools -> Correspondence
  CORRESPONDENCE_SEARCH_CONTROL = 300000,
  CORRESPONDENCE_CONTROL = 300000,
  CORRESPONDENCE_SEARCH = 300000,
  CORRESPONDENCE = 30000,
  CORRESPONDENCE_MERGE_FIELD_LIST = 30000,
  CORRESPONDENCES = 300000,
  //End Admin -> Admin tools -> Correspondence

  //start Admin-> Admin tools -> Speciality Group
  SPECIALITY_GROUP_SEARCH = 30000,
  FETCH_SPECIALITY_GROUP = 30000,
  SAVE_SPECIALITY_GROUPS = 30000,
  //End Admin -> Admin tools -> Speciality Group

  //start Admin-> Admin tools -> Text Message Alerts
  TEXT_MESSAGE_ALERT_SEARCH_CONTROL = 300000,
  TEXT_MESSAGE_ALERT_SEARCH = 30000,
  TEXT_MESSAGE_ALERT_SUGGEST = 30000,
  TEXT_MESSAGE_ALERT_CONTROL = 300000,
  TEXT_MESSAGE_ALERT = 300000,
  SEND_ALERT_CONFIGURATION_CONTROL = 300000,
  SAVE_TEXT_MESSAGE_ALERTS = 300000,
  //End Admin -> Admin tools -> Text Message Alerts

  //start Admin-> Admin tools -> Change Activity Description
  CHANGE_ACTIVITY_DESCRIPTION = 30000,
  CHANGE_ACTIVITY_DESCRIPTIONS = 30000,
  //End Admin -> Admin tools -> Change Activity Description

  // start Admin -> Admin tools -> User Management
  USER_MANAGEMENT_CONTROLS = 30000,
  SEARCH_USER_MANAGEMENT_LIST = 30000,

  // start Admin -> Admin tools -> User Group & Division Mapping
  ADMIN_USER_GROUP_DIVISION_MAPPING_SERCH_CONTROL_GET = 30000,
  ADMIN_GROUP_DIVISION_MAPPING_SEARCH_POST = 30000,
  FETCH_ADMIN_USER_GROUP_DIVISION_MAPPING = 30000,
  USER_GROUP_DIVISION_MAPPING_CONTROL = 30000,
  SAVE_ADMIN_USER_GROUP_DIVISION_MAPPINGS = 30000,
  //End Admin -> Admin tools -> User Group & Division Mapping

  // start Admin -> Activity Configuration -> Activity Assignment
  ACTIVITY_ASSIGNMENT_SEARCH = 300000,
  FETCH_ACTIVITY_ASSIGNMENT = 30000,
  ACTIVITY_ASSIGNMENT_CONTROL = 30000,
  ACTIVITY_ASSIGNMENT_FACULTY_SEARCH = 30000,
  ACTIVITY_ASSIGNMENT_FACULTY_SEARCH_CONTROL = 30000,
  ACTIVITY_ASSIGNMENT_REASSIGN = 30000,
  SAVE_ACTIVITY_ASSIGNMENTS = 30000,
  //End Admin -> Activity Configuration -> Activity Assignment

  // start Admin -> Activity Configuration -> Activity Auto-Cancel
  ACTIVITY_AUTO_CANCEL_SEARCH_CONTROL = 300000,
  ACTIVITY_AUTO_CANCEL_SUGGEST = 30000,
  FETCH_ACTIVITY_AUTO_CANCEL_SEARCH = 300000,
  ACTIVITY_AUTO_CANCEL_CONTROL = 30000,
  FETCH_ACTIVITY_AUTO_CANCEL = 30000,
  SAVE_ACTIVITY_AUTO_CANCEL = 30000,
  //End Admin -> Activity Configuration -> Activity Auto-Cancel

  // start Admin -> Activity Configuration -> Activity Description
  ACTIVITY_DESCRIPTION_SEARCH_CONTROL = 300000,
  FETCH_ACTIVITY_DESCRIPTION_SEARCH = 300000,
  ACTIVITY_DESCRIPTION_LEGAL_LANGUAGE = 30000,
  ACTIVITY_DESCRIPTION_LEGAL_LANGUAGES = 30000,
  ACTIVITY_DESCRIPTION_TRAVEL_TYPE = 30000,
  ACTIVITY_DESCRIPTION_TRAVEL_TYPES = 30000,
  ACTIVITY_DESCRIPTION_CONTROL = 30000,
  ACTIVITY_DESCRIPTION = 30000,
  SAVE_ACTIVITY_DESCRIPTIONS = 30000,
  ACTIVITY_DESCRIPTION_REFRESH_COMMENTS = 30000,
  ACTIVITY_DESCRIPTION_DELETE_COMMENTS = 30000,
  ACTIVITY_DESCRIPTION_WORKFLOW_CONFIGURATION = 30000,
  ACTIVITY_DESCRIPTION_WORKFLOW_CONFIGURATIONS = 30000,
  ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORY_CONTROL = 30000,
  ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORY_PRIMARY = 30000,
  ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORY_SECONDARY = 30000,
  ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORY = 30000,
  ACTIVITY_DESCRIPTION_FINANCIAL_CATEGORIES = 30000,

  //End Admin -> Activity Configuration -> Activity Description

  //start Admin -> Admin tools -> Rep Evaluation Config
  REP_EVALUATION_CONFIG_SEARCH = 300000,
  REP_EVALUATION_CONFIG_FILE = 120000,
  REP_EVALUATION_CONFIG = 120000,
  REP_EVALUATION_CONFIG_SAVE = 120000,
  //

  //start Admin -> Admin tools -> Budget Exemption
  BUDGET_EXPEMPTION_SEARCH = 120000,
  BUDGET_EXPEMPTION_DELETE = 120000,
  BUDGET_EXPEMPTION_CONTROLS = 120000,
  BUDGET_EXPEMPTION_SAVE = 120000,
  BUDGET_EXPEMPTION_FETCH = 120000,

  // start Admin -> Admin tools -> User Management
  GET_USER_MANAGEMENT_COMMENT = 30000,
  SAVE_USER_MANAGEMENT_COMMENT = 30000,
  USER_MANAGEMENT_ACCOUNT_RESET_PASSWORD = 30000,
  USER_MANAGEMENT_ACCOUNT_EMAIL_PASSWORD = 30000,
  USER_MANAGEMENT_ACCOUNT_EMAIL_USERID = 30000,
  USER_MANAGEMENT_ACCOUNT_RESER_SECURITY_QUESTION = 30000,
  FETCH_USER_MANAGEMENT_ACCOUNT_MFA = 30000,
  SAVE_USER_MANAGEMENT_ACCOUNT_MFA = 30000,
  USER_MANAGEMENT_NEW_USER_ACCOUNT_CONTROLLER = 30000,
  SAVE_USER_MANAGEMENT_NEW_USER_ACCOUNT = 30000,
  SEARCH_FR_USER_MANAGEMENT_LIST = 30000,
  GET_FR_USER_MANAGEMENT_DATA = 30000,
  SEARCH_USER_MANAGEMENT_ALIGNMENT = 30000,
  SHOW_USER_MANAGEMENT_TABS = 30000,
  SAVE_NEW_USER_MANAGEMENT = 30000,
  SAVE_EDIT_USER_MANAGEMENT = 30000,
  GET_USER_MANAGEMENT_USER_ACCOUNT = 30000,
  GET_USER_MANAGEMENT_USER_PROFILE = 30000,
  SAVE_USER_MANAGEMENT_USER_PROFILE = 30000,
  GET_USER_MANAGEMENT_PROFILE_ALIGNMENT = 30000,
  GET_USER_MANAGEMENT_ASSIGN_GROUP_CONTROLLER = 30000,
  SAVE_USER_MANAGEMENT_ASSIGN_GROUP = 30000,

  // start Admin -> Activity Configuration -> Expense Management
  EXPENSE_MANAGEMENT_SEARCH_CONTROLLER = 30000,
  EXPENSE_MANAGEMENT_SEARCH = 30000,
  GET_EXPENSE_MANAGEMENT_DETAILS_CONTROLLER = 30000,
  GET_EXPENSE_MANAGEMENT_DETAILS = 30000,
  SAVE_EXPENSE_MANAGEMENT_DETAILS = 120000,

  // start Admin -> Activity Configuration -> Honorarium Management Advising
  HONORARIUM_MANAGEMENT_ADV_SEARCH_CONTROL = 120000,
  HONORARIUM_MANAGEMENT_ADV_SEARCH = 300000,
  HONORARIUM_MANAGEMENT_ADV_CONTROL = 120000,
  HONORARIUM_MANAGEMENT_ADV_DETAILS = 120000,
  HONORARIUM_MANAGEMENT_ADV_SAVE = 120000,
  // start Admin -> Activity Configuration -> Faculty Selection
  GET_FACULTY_SELECTION_CONTROLLER = 30000,
  SEARCH_FACULTY_SELECTION = 300000,
  GET_FACULTY_SELECTION = 30000,
  SAVE_FACULTY_SELECTION = 30000,

  //Admin -> Activity Configuration -> Attendee Program Block
  FETCH_ATTENDEE_PROGRAM_BLOCK_CONTROLS = 120000,
  FETCH_ATTENDEE_TRAINED_RULE_DETAILS = 120000,
  FETCH_FACULTY_ATTENDEE_RULE_DETAILS = 120000,
  SAVE_ATTENDEE_TRAINED_RULE_DETAILS = 120000,
  SAVE_FACULTY_ATTENDEE_RULE_DETAILS = 120000,
  ATTENDEE_PROGRAM_CAP_RULE_SEARCH_CONTROL = 120000,
  ATTENDEE_PROGRAM_CAP_RULE_SEARCH = 30000,
  ATTENDEE_PROGRAM_CAP_RULE_CONTROL = 120000,
  ATTENDEE_PROGRAM_CAP_RULE = 30000,
  ATTENDEE_PROGRAM_CAP_RULES = 120000,

  // start Admin -> Activity Configuration -> Tier - Brand Mapping
  TIER_BRAND_MAPPING_SEARCH_CONTROL = 120000,
  TIER_BRAND_MAPPING_SEARCH = 300000,
  TIER_BRAND_MAPPING_CONTROL = 120000,
  TIER_BRAND_MAPPING_DETAIL = 120000,
  TIER_BRAND_MAPPING_SAVE = 120000,

  //start Admin -> Activity Configuration -> Medical Tier Admin
  MEDICAL_TIER_ADMIN_CONTROL = 120000,
  MEDICAL_TIER_ADMIN_SEARCH = 120000,
  MEDICAL_TIER_ADMIN_SAVE = 120000,

  //Admin -> Activity Configuration -> Activity Rule
  ACTIVITY_RULE_SEARCH_CONTROL = 120000,
  ACTIVITY_RULE_SEARCH = 300000,
  ACTIVITY_RULE_TOWN_SUGGEST = 30000,
  ACTIVITY_RULE_FACULTY_SUGGEST = 80000,
  ACTIVITY_RULE_ACTIVITYID = 30000,
  ACTIVITY_RULE_DOWNLOAD = 300000,
  SALES_ORG_RESTRICTION_CONTROL = 30000,
  SALES_ORG_RESTRICTION_SEARCH = 30000,
  SALESFORCE_ACCESS_CONTROL = 30000,
  SALESFORCE_ACCESS_SEARCH = 30000,
  ACTIVITY_RULE_CONTROL = 30000,
  ACTIVITY_RULE = 30000,
  ACTIVITY_RULES = 30000,
  //END

  //Admin -> Activity Configuration -> Homorarium Travel
  HONORARIUM_TRAVEL_SEARCH_CONTROL = 300000,
  HONORARIUM_TRAVEL_SEARCH = 300000,
  HONORARIUM_TRAVEL_CONTROL = 300000,
  HONORARIUM_TRAVEL_DATA = 30000,
  SAVE_HONORARIUM_TRAVELS_DATA = 30000,
  //END

  //Admin -> Activity Configuration -> Homorarium Admin
  HONORARIUM_ADMIN_SEARCH_CONTROL = 300000,
  HONORARIUM_ADMIN_SEARCH = 300000,
  HONORARIUM_ADMIN_CONTROL = 300000,
  HONORARIUM_ADMIN_DATA = 30000,
  HONORARIUM_ADMIN_EXTEND_TIER = 30000,
  HONORARIUM_ADMIN_COPY_TIER = 30000,
  HONORARIUM_ADMIN_DOWNLOAD = 300000,
  SAVE_HONORARIUM_ADMIN_DATA = 30000,
  //END

  //start Admin ->  Activity Configuration -> Honorarium Management FDA
  HONORARIUM_MGMT_FDA_SEARCH_CONTROL = 120000,
  HONORARIUM_MGMT_FDA_SEARCH = 300000,
  HONORARIUM_MGMT_FDA_CONTROL = 120000,
  HONORARIUM_MGMT_FDA_DETAIL = 120000,
  HONORARIUM_MGMT_FDA_SAVE = 300000,

  //start Admin ->  Survey -> Survey Question
  QUESTION_LIST_CONTROL = 120000,
  QUESTION_LIST_SEARCH = 30000,
  SURVEY_QUESTION_CONTROL = 120000,
  SURVEY_QUESTIONS = 300000,
  SURVEY_QUESTION = 300000,
  SURVEY_CONTACT_NOTE = 300000,
  SURVEYBU_LIST_CONTROL = 120000,
  SURVEY_BU_CONTROL = 120000,
  SURVEY_BUS = 300000,
  SURVEY_DELETE_TARGETUSERS = 600000,
  SURVEY_BU = 30000,
  SURVEY_BU_LOADFACULTY = 30000,
  SURVEY_BU_DOWNLOAD = 120000,
  SURVEY_BUDELETE = 30000,
  SURVEY_BU_LIST_SEARCH = 120000,
  SURVEY_LIST_CONTROL = 120000,
  SURVEY_CONFIGURATIONS = 300000,
  SURVEY_CONFIGURATION = 30000,
  SURVEY_FRTARGETUSERS_CONTROL = 120000,
  SURVEY_CONFIGURATION_CONTROL = 120000,
  SURVEY_SEARCH_FRTARGETUSERS = 600000,
  SURVEY_FETCH_FRTARGETUSERBUDETAILS = 120000,
  SURVEY_FETCH_TARGETUSERDETAILS = 120000,
  SURVEY_SEARCH_TARGETUSERS = 600000,
  SURVEY_STATS_SEARCH = 900000,
  SURVEY_CONFIGURATION_LIST_SEARCH = 30000,
  SURVEY_TARGETUSER_STATUS = 120000,
  SURVEY_TARGETUSER_DOWNLOAD = 30000,
  SURVEY_TU_DELETE_COMMENT = 120000,
  SURVEY_DATATRANSFORM_STATS_SEARCH = 900000,

  //start Admin ->  Activity Configuration -> Honorarium Management Medical
  HONORARIUM_MGMT_MEDICAL_SEARCH_CONTROL = 120000,
  HONORARIUM_MGMT_MEDICAL_SEARCH = 300000,
  HONORARIUM_MGMT_MEDICAL_CONTROLS = 120000,
  HONORARIUM_MGMT_MEDICAL_DETAILS = 120000,
  HONORARIUM_MGMT_MEDICAL_SAVE = 300000,

  //start Activity -> ORF
  ARF_FORM_CONTROL = 120000,
  ARF_FORM_FACULTY = 120000,
  ARF_FORM_ACTIVITY = 120000,
  ARF_FORM_SAVE = 120000,
  ARF_FORM_DETAIL = 120000,

  //start Activity -> ARF
  REQUEST_FORM_CONTROL = 120000,
  REQUEST_FORM_TL_MAP_SEARCH = 120000,
  FETCH_REQUEST_FORM = 120000,
  REQUEST_FORM_NOTES = 120000,
  REQUEST_FORM_ATTACHMENTS = 120000,
  FETCH_REQUEST_FORM_ATTACHMENT = 120000,
  REQUEST_FORM_ATTACHMENT_FILE = 120000,
  FETCH_GOOGLE_ADDRESS = 120000,
  SAVE_REQUEST_FORMS = 120000,
  VERIFY_GOOGLE_RE_CAPTCHA = 30000,
  FETCH_PARTICIPANT_CV_FILE = 120000,
  FETCH_COST_CENTER = 120000,
  FETCH_PARTICIPANT_FORM = 120000,
  //end

  //start Activity -> Invoice Detail
  INVOICE_DETAIL_CONTROL = 120000,
  INVOICE_DETAIL_SEARCH = 300000,
  INVOICE_DETAIL_DELETE = 120000,
  INVOICE_DETAIL_FACULTY_SEARCH = 120000,
  INVOICE_DETAIL_FACULTY = 120000,
  INVOICE_DETAIL_HISTORY = 120000,
  INVOICE_DETAIL = 120000,
  INVOICE_DETAIL_DOWNLOAD = 120000,
  SAVE_INVOICE_DETAILS = 120000,
  //end

  //start Activity -> Pymt Mgmt Tools -> Add Expense Detail
  EXPENSE_DETAILS_CONTROL = 120000,
  EXPENSE_DETAILS_SEARCH = 300000,
  EXPENSE_DETAILS_DELETE = 120000,
  EXPENSE_DETAILS_HISTORY = 120000,
  EXPENSE_DETAILS_FACULTY_SEARCH = 120000,
  EXPENSE_DETAILS_FACULTY = 120000,
  EXPENSE_DETAILS_FACULTY_EXCEPTION_CONTROL = 120000,
  EXPENSE_DETAILS_FACULTY_EXCEPTION = 120000,
  EXPENSE_DETAILS_FACULTY_EXCEPTIONS_SAVE = 120000,
  EXPENSE_DETAILS = 120000,
  EXPENSE_FILE_DOWNLOAD = 300000,
  EXPENSE_SAVE = 120000,
  EXPENSE_DETAIL_DOWNLOAD = 300000,
  DUPLICATE_EXPENSE_DETAIL = 120000,

  //start Activity -> Add Comment Pop Up
  FETCH_ACTIVITY_COMMENT = 120000,
  ACTIVITY_COMMENTS = 120000,
  //end

  //start Activity -> Activity History
  ACTIVITY_HISTORY = 300000,
  //end

  //start Activity -> Activity History
  ACTIVITY_FACULTIES = 120000,
  //end

  //Activity -> View Itinerary
  VIEW_ITINERARY_PNR = 120000,
  // Activity -> Expense Correspondence Search
  ACTIVITY_EXPENSE_CORRESPONDENCE_CONTROL = 30000,
  ACTIVITY_EXPENSE_CORRESPONDENCE_SEARCH = 30000,
  FETCH_EXPENSE_CORRESPONDENCE_DETAILS = 30000,
  SAVE_EXPENSE_CORRESPONDENCE_DETAILS = 30000,
  SEND_CORRESPONDENCE = 120000,
  SEND_CORRESPONDENCE_BRAND = 120000,
  SEND_CORRESPONDENCE_EMAILS = 120000,

  // Activity -> Basic Search ARF
  ARF_BASIC_SEARCH_CONTROL = 30000,
  ARF_BASIC_SEARCH_RESULT = 120000,
  ARF_ADVANCE_SEARCH_CONTROL = 30000,
  ARF_ADVANCE_SEARCH_RESULT = 120000,
  PID_SEARCH = 30000,
  PNR_GENERATE = 30000,

  // Activity -> Activity Basic Search
  ACTIVITY_BASIC_SEARCH_CONTROL = 30000,
  ACTIVITY_BASIC_SEARCH_RESULT = 120000,
  ACTIVITY_ADVANCE_SEARCH_CONTROL = 30000,
  ACTIVITY_ADVANCE_SEARCH_RESULT = 120000,
  //Activity -> Multiple Activities Pop up
  MULTIPLE_FACULTY_ACTIVITIES = 120000,

  //Activity -> Activity Map
  ACTIVITY_MAP_CONTROLS = 30000,
  ACTIVITY_MAP_FILTER = 30000,

  //Activity -> Directions
  ACTIVITY_DIRECTION_SEARCH = 300000,
  ACTIVITY_DIRECTION_SEARCH_CONTROLS = 30000,
  ACTIVITY_DIRECTION = 30000,
  //Activity -> Check Status
  CHECK_STATUS_DETAILS = 120000,
  CHECK_STATUS_EXPENSE_FORM_DOWNLOAD = 300000,
  CHECK_TYPE_REISSUE = 120000,
  CHECK_STATUS_DOWNLOAD = 300000,

  //Activity -> Activity Meetings
  ACTIVITY_MEETING_LIST = 120000,
  ACTIVITY_MEETING_LIST_SAVE = 120000,
  ACTIVITY_MEETING_DELETE = 120000,
  ACTIVITY_MEETING_HCP_REGISTRATION_RESET = 120000,
  COST_CATEGORY_ALLOCATION_FETCH = 120000,
  COST_CATEGORY_ALLOCATION_SAVE = 120000,
  ACTIVITY_MEETING = 120000,
  GOOGEL_ADDRESS_VALIDATE = 120000,
  ACTIVITY_MEETING_SAVE = 120000,
  //Activity -> InfoSheet Popup
  ACTIVITY_INFOSHEET_MEDICAL = 30000,
  ACTIVITY_INFOSHEET_LTS = 30000,
  ACTIVITY_INFOSHEET_BRAND = 30000,
  ACTIVITY_INFOSHEET_FEEDBACK = 30000,
  ACTIVITY_INFOSHEET = 30000,
  ACTIVITY_INFOSHEET_FIELD_LTS = 30000,
  // Activity -> Activity Calendar
  ACTIVITY_CALENDAR_CONTROL = 30000,
  ACTIVITY_CALENDAR_FILTER = 30000,
  ACTIVITY_CALENDAR = 30000,
  // Activity -> Medical Activity
  MEDICAL_ACTIVITY_CONTROL = 30000,

  // Activity -> Payment Request
  ACTIVITY_GET_PAYMENT_REQUEST = 300000,
  ACTIVITY_EXPENSE_FORM_DOWNLOAD = 120000,
  PAYMENT_REQUEST_SIGNIN_SHEET = 120000,
  COMPLIANCE_ACKNOWLEDGE_FORM_FACULTY = 180000,
  PAYMENT_REQUEST_CONTRACT = 180000,
  PAYMENT_REQUEST_FILE = 180000,
  PAYMENT_REQUEST_GET_COMPLIANCE_FORM = 180000,
  PAYMENT_REQUEST_SAVE_COMPLIANCE_FORM = 180000,
  PAYMENT_REQUEST_SAVE_ADVISING_HONORARIUM = 120000,
  PAYMENT_REQUEST_GET_ADVISING_HONORARIUM_DETAILS = 120000,
  PAYMENT_REQUEST_GET_RELATED_ACTIVITIES = 120000,
  PAYMENT_REQUEST_RELATED_ACTIVITIES_REFRESH = 120000,
  PAYMENT_REQUEST_SAVE_RELATED_ACTIVITIES = 120000,
  PAYMENT_REQUEST_LINKED_ACTIVITY_SEARCH = 120000,
  PAYMENT_REQUEST_LINKED_ACTIVITY_CONTROL = 120000,
  PAYMENT_REQUEST_DOWNLOAD_RELATED_ACTIVITIES = 120000,
  ACTIVITY_SAVE_PAYMENT_REQUEST = 120000,
  ACTIVITY_PERMISSION = 120000,
  MEDICAL_ACTIVITY_GRAND_SUPPLIER_ACCESS = 30000,
  MEDICAL_ACTIVITY_GRAND_SUPPLIER_ACCESSES = 30000,
  MEDICAL_ACTIVITY_GRAND_SUPPLIER_ACCESS_GENERATE_PIN = 30000,
  MEDICAL_CONSULTANTS_SEARCH = 120000,
  MEDICAL_ACTIVITY_COMMENT = 120000,
  MEDICAL_ACTIVITY_COMMENTS = 120000,
  MEDICAL_ACTIVITY_INFORMATION = 180000,
  MEDICAL_ACTIVITY_APPROVAL_STATUS = 120000,
  MEDICAL_CONSULTANT_APPROAL_STATUS = 120000,
  MEDICAL_ACTIVITY_TRIALALIAS = 180000,
  ACTIVITY_FACULTY_DETAILS = 120000,
  MEDICAL_ACTIVITY_CONSULTANT_STATUS_LEGEND = 30000,
  MEDICAL_CONTRACT_PREVIEW = 180000,
  MEDICAL_ACTIVITY_INFORMATIONS = 180000,
  MEDICAL_RESET_CONSULTANT_ROLE = 30000,
  CONSULTANT_SEARCH_CONTROL = 120000,
  NEW_CONSULTANT_CONTROL = 120000,
  VALIDATE_CONSULTANTS = 30000,
  FACULTY_CONTRACT_AVAILABLE = 30000,
  CONSULTANT_TERMINATION_CONTROL = 120000,
  CONSULTANT_CANCELLATION_CONTROL = 120000,
  ACTIVITY_FACULTY_TIERS = 30000,
  CONSULTANT_CONTRACT_INFO_CONTROL = 120000,

  FIELD_ACTIVITY_DOWNLOAD_PID_DISTRIBUTION_EXCEL = 120000,
  FIELD_ACTIVITY_CONFIRM_FACULTY = 120000,
  FIELD_ACTIVITY_DELETE_FACULTY = 120000,
  FIELD_ACTIVITY_RETAIN_ACTIVITY_INFORMATION = 120000,
  FIELD_ACTIVITY_OVCHANGE = 120000,
  FIELD_ACTIVITY_INVITEE_LIST = 120000,
  UPLOAD_INVITEE = 120000,
  DOWNLOAD_BRAND_TEMPLATE = 300000,
  INVITEE_FILE_DOWNLOAD = 300000,
  IS_INVITEE_DELETE = 300000,
  GET_INVITEE_SIGNATURE = 300000,
  SAVE_INVITEE_SIGNATURE = 300000,
  CHECK_INVITEE_SIS = 300000,
  SIGN_IN_SHEET_CONTROL = 300000,
  SAVE_SIGN_IN_SHEET = 300000,
  SAVE_EMAIL_INVITEE = 300000,
  GENERATE_SIS = 300000,
  DOWNLOAD_SIS_FILE = 300000,
  GET_MEETING_MATERIAL_CONTROL = 300000,
  SAVE_MEETING_MATERIAL = 300000,
  DELETE_MEETING_MATERIAL = 300000,
  FETCH_MEETING_MATERIAL_FILE = 300000,
  FETCH_ACTIVITY_SUMMARY_FILE = 300000,
  FETCH_PARTNER_REPRESENTATIVE = 300000,
  FETCH_FINANCIAL_VALIDATION = 300000,
  FETCH_FINANCIAL_VALIDATION_RECEIPT = 300000,
  DOWNLOAD_FINANCIAL_VALIDATION_EXCEL = 300000,
  CHECK_MISSING_LILLY_CUSTOMERID = 300000,
  SAVE_FINANCIAL_VALIDATION = 300000,
  GET_ARF = 120000,
  CHECK_ARF = 120000,
  SAVE_FEEDBACK_ACTIVITY_INFORMATION = 300000,
  CHECK_INDIVIDUAL_PAYMENTS_LIMIT = 120000,
  SAVE_FIELD_ACTIVITY_INFORMATION = 120000,
  SAVE_FIELD_ACTIVITY = 120000,

  FEEDBACK_ACTIVITY_INFORMATION = 300000,
  FACULTY_DOCUMENT = 120000,
  ADD_ARF_PARTICIPANT = 120000,
  ADD_LINKED_ACTIVITY_SEARCH = 120000,
  ADD_LINKED_ACTIVITY_CONTROL = 120000,
  FETCH_PNR_RELATED_ACTIVITIES = 120000,
  SAVE_PNR_RELATED_ACTIVITIES = 120000,
  CONTRACT_TEMPLATE_DELETE_COMMENTS = 300000,
  CONTRACT_TEMPLATE_REFRESH_COMMENTS = 300000,
}
export enum AddActivityActivityTypes {
  ADVISORY_BOARDS_SINGLE_ADVISOR_ACTIVITY = 1,
  MARKETING_ONLY_ACTIVITY_TYPE = 2,
  OTHER_SERVICES_ACTIVITY_TYPE = 4,
  OUS_AFFILIATE_INITIATED_ACTIVITY_TYPE = 3,
}

export enum ActivityTypePageIds {
  FIELD_ACTIVITY = 25,
  MEDICAL_ACTIVITY = 2190,
  ADVISING_ACTIVITY = 2117,
  BRAND_ACTIVITY = 24,
}

export enum ConsultantFeeForService {
  PLEASE_SELECT = -1,
  HOURLY = 1,
  MILESTONE = 2,
}

export enum ConsultantPaymentType {
  PLEASE_SELECT = -1,
}

export enum BreadcrumbIds {
  ACTIVITY_INFO = 9,
  DATE_AND_TIME = 10,
  REPRESENTATIVE = 16,
  LOCATION = 12,
  FACULTY = 11,
  AUDIENCE = 98,
  OLD_AUDIENCE = 13,
  TRAVEL = 14,
  COMMENTS = 15,
  PROGRAM_CLOSE_OUT = 99,
  MEETING_COST_INFO = 77,
  PROGRAM_VALIDATION = 85,
  ADVISORY_DESCRIPTION = 70,
  BRAND_ACTIVITY_PROGRAM_CLOSE_OUT = 103,
  ADVISING_ACTIVITY_PROGRAM_CLOSE_OUT = 101,
  BRAND_ACTIVITY_AUDIENCE = 102,
  ADVISING_ACTIVITY_AUDIENCE = 100,
  PROGRAM_CLOSE_OUT_PROGRAM_VALIDATION = 1,
  BRAND_ACTIVITY_ACTIVITY_INFO = 1,
  BRAND_ACTIVITY_COMMENTS = 8,
  BRAND_ADVISORY_DESCRIPTION = 4,
  BRAND_ACTIVITY_FINANCE = 5,
  FEEDBACK_ACTIVITY_INFO = 67,
  FEEDBACK_ACTIVITY_PROGRAM_CLOSE_OUT = 101,
  FEEDBACK_ACTIVITY_LOCATION = 68,
  FEEDBACK_ACTIVITY_PARTICIPANTS_INFORMATION = 69,
  FEEDBACK_ACTIVITY_ADVISORY_DESCRIPTION = 70,
  FEEDBACK_ACTIVITY_COMMENTS = 72,
}


export enum UserType {
  ADMIN = 1,
  SUPER_USER = 3,
}